{
  "checkInLocationIsOutsideThe": "You are {{0}} m from the allowed check-in area (office limit is {{1}} m). Move closer, enable precise location on your phone, or ask HR to verify the office coordinates and radius.",
  "checkOutLocationIsOutsideThe": "You are {{0}} m from the allowed check-out area (office limit is {{1}} m). Move closer, enable precise location on your phone, or ask HR to verify the office coordinates and radius.",
  "dashboard": {
    "title": "HR Dashboard",
    "payrollRuns": "Payroll runs",
    "openPositions": "Open positions",
    "employeesReady": "Employees ready",
    "pendingAttendance": "Pending attendance",
    "pendingTimesheets": "Pending timesheets",
    "pendingAllowances": "Pending allowances",
    "pendingExpenses": "Pending expenses",
    "pendingClaims": "Pending claims",
    "payrollReady": "Payroll ready",
    "payrollExceptions": "Payroll exceptions",
    "totalPayrollCost": "Total payroll cost",
    "allowanceCost": "Allowance cost",
    "expenseCost": "Expense cost",
    "claimCost": "Claim cost"
  },
  "attendance": {
    "title": "Attendance and Leave",
    "tabs": {
      "attendance": "Attendance",
      "leave": "Leave",
      "overtime": "Overtime"
    },
    "recordTabs": {
      "all": "All",
      "attendance": "Attendance",
      "leave": "Leave"
    },
    "newRecord": "New record",
    "addRecord": "Add record",
    "recordType": "Record type",
    "aria": {
      "attendanceAndLeave": "Attendance and leave"
    },
    "detail": {
      "checkIn": "Check in",
      "checkOut": "Check out",
      "source": "Source",
      "overtime": "OT",
      "worked": "Worked",
      "time": "Time",
      "date": "Date",
      "status": "Status",
      "approval": "Approval",
      "pendingMinutes": "{{minutes}} pending approval"
    },
    "segments": {
      "title": "Hours breakdown",
      "loading": "Loading breakdown…",
      "summary": "Regular {{regular}} · Overtime {{overtime}}",
      "summaryWithBreak": "Regular {{regular}} · Overtime {{overtime}} · Break {{break}}",
      "includesBreak": "incl. {{break}} break",
      "splitCount_one": "{{count}} overtime split",
      "splitCount_other": "{{count}} overtime splits",
      "types": {
        "REGULAR": "Shift",
        "OVERTIME_BEFORE_SHIFT": "OT before shift",
        "OVERTIME_BETWEEN_SHIFTS": "OT between shifts",
        "OVERTIME_AFTER_SHIFT": "OT after shift",
        "OVERTIME_UNSCHEDULED": "OT unscheduled day",
        "BREAK": "Break"
      }
    },
    "modes": {
      "MANUAL": "Manual attendance",
      "WEB": "Web attendance",
      "MOBILE": "Mobile attendance",
      "BIOMETRIC": "Biometric attendance",
      "RFID": "RFID attendance",
      "QR": "QR attendance",
      "GEO": "Geo attendance",
      "REGULARIZATION": "Regularized attendance"
    },
    "status": {
      "present": "Present",
      "absent": "Absent",
      "late": "Late",
      "halfDay": "Half day",
      "wfh": "Work from home",
      "holiday": "Holiday",
      "weekend": "Weekend"
    },
    "leaveStatus": {
      "pending": "Pending",
      "returned": "Returned",
      "submitted": "Submitted",
      "approved": "Approved",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "durationMode": {
      "fullDay": "Full day",
      "halfDay": "Half day",
      "hourly": "Hourly",
      "shift": "Specific shift"
    },
    "metrics": {
      "worked": "Worked",
      "leave": "Leave",
      "overtime": "OT"
    },
    "actions": {
      "recordAttendance": "Record attendance",
      "createLeave": "Create leave",
      "checkOut": "Check out",
      "geoCheckOut": "Geo check-out",
      "pendingApproval": "Pending approval"
    },
    "kind": {
      "attendance": "Attendance",
      "overtime": "Overtime"
    },
    "hints": {
      "bulkAttendance": "Record the same attendance entry for one or more employees.",
      "bulkLeave": "Create the same leave request for one or more employees."
    },
    "empty": {
      "noEmployees": "No employees in your visibility scope — adjust filters or hierarchy."
    },
    "toast": {
      "checkOutRecorded": "Check-out recorded",
      "attendanceRecorded": "Attendance recorded",
      "leaveCreated": "Leave request created",
      "cancellationSubmitted": "Cancellation submitted for approval",
      "leaveCancelled": "Leave cancelled",
      "attendanceCancelled": "Attendance cancelled",
      "overtimeCancelled": "Overtime cancelled",
      "selectEmployee": "Select at least one employee"
    },
    "errors": {
      "checkInRequired": "Check-in time is required",
      "checkOutAfterCheckIn": "Check-out must be after check-in",
      "overtimeTypeRequired": "Select an overtime type when worked time exceeds expected hours",
      "leaveTypeRequired": "Leave type and at least one day are required",
      "leaveTypeOnly": "Leave type is required",
      "leaveDayRequired": "Select at least one leave day",
      "leaveReasonRequired": "Leave reason is required",
      "attachmentUploadFailed": "Failed to upload attachment",
      "checkOutFailed": "Check-out failed",
      "markAttendanceFailed": "Failed to mark attendance",
      "createLeaveFailed": "Failed to create leave",
      "cancelFailed": "Cancel failed"
    }
  },
  "payroll": {
    "title": "Payroll",
    "newRun": "New payroll run",
    "periodStart": "Period start",
    "periodEnd": "Period end",
    "createRun": "Create run",
    "workflowHint": "Workflow: create run → approve → calculate. Calculation uses org formulas when configured, otherwise a statutory fallback rate.",
    "formulasActive": "{{count}} active formula(s): {{codes}}",
    "noFormulasFallback": "No country formulas — fallback statutory rate will apply",
    "calculate": "Calculate",
    "calculateUsingFormulas": "Calculate using {{count}} formula(s)",
    "calculateStatutoryFallback": "Calculate using statutory fallback rate",
    "approveBeforeCalculate": "Approve this run before calculating",
    "inStatutory": "IN statutory",
    "bankFile": "Bank file",
    "transactions": "Transactions",
    "transactionsModalTitle": "Payroll transactions",
    "transactionsModalTitleRun": "Transactions — {{runCode}}"
  },
  "leave": {
    "title": "Leave",
    "request": "Request leave",
    "balance": "Leave balance"
  },
  "calendar": {
    "granularity": {
      "year": "Year",
      "month": "Month",
      "week": "Week",
      "day": "Day"
    },
    "timeDisplay": {
      "hours": "Hours",
      "days": "Days",
      "both": "Both"
    },
    "weekNumber": "Week {{n}}",
    "weekShortPrefix": "W{{n}} · ",
    "employee": "Employee",
    "employeeExpected": "Emp. hrs",
    "expected": "Expected",
    "totalHours": "Total hrs",
    "noEmployees": "No employees to display",
    "legend": {
      "workingDay": "Working day",
      "halfDay": "Half day",
      "offDay": "Off day",
      "holiday": "Holiday",
      "special": "Special",
      "worked": "Worked",
      "leave": "Leave",
      "overtime": "OT",
      "pendingApproval": "Pending approval",
      "companyHours": "Company hours",
      "assignedShift": "Assigned shift"
    },
    "schedulePanel": {
      "companyHoursTitle": "Company hours",
      "scheduledShiftTitle": "Scheduled shift",
      "scheduledShiftsTitle": "Scheduled shifts ({{count}})",
      "hours": "Hours",
      "shift": "Shift",
      "time": "Time",
      "expected": "Expected",
      "unpaidBreaks": "Unpaid breaks",
      "breakPeriods": "Break periods",
      "source": "Source",
      "companyDefault": "Company default",
      "companyCalendar": "Company calendar",
      "companyCalendarDay": "Company calendar day",
      "shiftSource": "Shift",
      "shiftFallback": "Shift",
      "paid": "Paid",
      "breakFallback": "Break {{index}}"
    },
    "units": {
      "hoursCount": "{{value}} hrs",
      "dayCountOne": "{{value}} day",
      "dayCountOther": "{{value}} days",
      "hrsSuffix": "(hrs)",
      "daysSuffix": "(days)"
    },
    "metricHeaderHours": "{{label}} (hrs)",
    "metricHeaderDays": "{{label}} (days)",
    "marker": {
      "present": "P",
      "overtime": "OT",
      "leaveFallback": "L"
    },
    "tooltip": {
      "workedApproved": "Worked (approved)",
      "workedPending": "Worked (pending)",
      "workedRejected": "Worked (rejected)",
      "workedCancelled": "Worked (cancelled)",
      "leaveApproved": "Leave (approved)",
      "leavePending": "Leave (pending)",
      "leaveRejected": "Leave (rejected)",
      "leaveCancelled": "Leave (cancelled)",
      "overtimeApproved": "OT (approved)",
      "overtimePending": "OT (pending)",
      "overtimeRejected": "OT (rejected)",
      "overtimeCancelled": "OT (cancelled)",
      "fromAttendance": "from attendance",
      "manualRequest": "manual request",
      "punches": "({{count}} punches)",
      "late": "late {{minutes}}",
      "leaveTypeFallback": "Leave",
      "fullDay": "full day"
    },
    "overtimeMinutesLabel": "{{minutes}} {{abbrev}}",
    "overtimeBadge": "{{abbrev}} {{status}}",
    "pendingOvertimeTrend": "{{minutes}} {{abbrev}} {{label}}"
  },
  "columns": {
    "code": "Code",
    "name": "Name",
    "status": "Status",
    "actions": "Actions",
    "description": "Description",
    "color": "Color",
    "employee": "Employee",
    "shift": "Shift",
    "hours": "Hours",
    "days": "Days",
    "type": "Type",
    "date": "Date",
    "title": "Title",
    "category": "Category",
    "provider": "Provider",
    "active": "Active",
    "location": "Location",
    "email": "Email",
    "role": "Role",
    "amount": "Amount",
    "comments": "Comments",
    "level": "Level",
    "grade": "Grade",
    "start": "Start",
    "end": "End",
    "score": "Score",
    "reason": "Reason",
    "content": "Content",
    "rating": "Rating",
    "reviewer": "Reviewer",
    "cycle": "Cycle",
    "details": "Details",
    "expiry": "Expiry",
    "download": "Download",
    "claim": "Claim",
    "from": "From",
    "to": "To",
    "run": "Run",
    "gross": "Gross",
    "net": "Net",
    "product": "Product",
    "revenue": "Revenue",
    "payment": "Payment",
    "invoiceNumber": "Invoice #",
    "quantitySold": "Qty sold",
    "rate": "Rate %",
    "taxable": "Taxable",
    "tax": "Tax",
    "lines": "Lines",
    "alertQty": "Alert qty",
    "need": "Need",
    "daysLeft": "Days left",
    "invoices": "Invoices",
    "sales": "Sales",
    "organization": "Organization",
    "platforms": "Platforms",
    "paid": "Paid",
    "carryForward": "Carry forward",
    "entitlement": "Entitlement",
    "used": "Used",
    "pending": "Pending",
    "available": "Available",
    "payrollMode": "Payroll mode",
    "hoursPerDay": "Hours/day",
    "endDateRequired": "End date required",
    "trackExpiry": "Track expiry",
    "receiptRequired": "Receipt required",
    "leaveType": "Leave type",
    "policy": "Policy",
    "annualDays": "Annual days",
    "accrual": "Accrual",
    "maxConsecutive": "Max consecutive",
    "carryForwardMax": "Carry forward max",
    "backdated": "Backdated",
    "nonWorking": "Full day off",
    "workingDays": "Working days",
    "defaultHours": "Default hours",
    "employment": "Employment",
    "headcount": "Headcount",
    "positions": "Positions",
    "position": "Position",
    "manpower": "Manpower",
    "source": "Source",
    "relationship": "Relationship",
    "grossAmount": "Gross amount",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "salaryStructure": "Salary structure",
    "structureName": "Structure name",
    "applicableDay": "Applicable day",
    "netAmount": "Net amount",
    "employeeId": "Employee ID",
    "deductions": "Deductions",
    "mode": "Mode",
    "inOut": "In / out",
    "open": "Open",
    "ot": "OT",
    "worked": "Worked",
    "week": "Week",
    "course": "Course",
    "tag": "Tag",
    "nonWorkingDay": "Full day off",
    "returnRequired": "Return required",
    "threshold": "Threshold",
    "dailyOt": "Daily OT",
    "weeklyOt": "Weekly OT",
    "billable": "Billable",
    "dayType": "Day type",
    "overallOtApproved": "Overall OT (approved)",
    "aggregateWeeklyOtCompany": "Aggregate weekly OT (company)",
    "requiredDocument": "Required document",
    "payRun": "Pay run"
  },
  "ess": {
    "tabs": {
      "home": "Home",
      "profile": "Profile",
      "schedule": "Schedule",
      "time": "Time",
      "leave": "Leave",
      "pay": "Pay",
      "approvals": "My requests"
    },
    "actions": {
      "refresh": "Refresh",
      "manualCheckOut": "Manual check-out",
      "geoCheckIn": "Geo check-in",
      "geoCheckOut": "Geo check-out",
      "updating": "Updating…",
      "openApprovalInbox": "Open approval inbox",
      "submitLeaveRequest": "Submit leave request",
      "updateDocuments": "Update documents",
      "timeAndAttendance": "Time & attendance",
      "fullSchedule": "Full schedule",
      "fullRoster": "Full roster →",
      "viewCalendar": "View calendar →",
      "viewTimeTab": "Time tab →",
      "viewLeaveTab": "Leave tab →",
      "viewPayTab": "Pay tab →",
      "viewRequestsTab": "Requests tab →",
      "viewProfileTab": "Profile →",
      "downloadPayslipAria": "Download payslip for run {{runCode}}"
    },
    "home": {
      "todayAtWork": "Today at work",
      "scheduleLoadsFromShifts": "Schedule loads from your assigned shifts and roster.",
      "manualCheckInOpen": "Manual check-in {{time}} · session open",
      "geoCheckInOpen": "Geo check-in {{time}} · session open",
      "expectedHoursMonth": "Expected hours (month)",
      "workedHoursApproved": "Worked hours (approved)",
      "overtimeApproved": "Overtime (approved)",
      "shiftAssignments": "Shift assignments",
      "companyDefault": "Company default",
      "loadingRoster": "Loading roster…",
      "loading": "Loading…",
      "requested": "{{days}} requested",
      "netAmount": "Net {{amount}}",
      "amountLabel": "Amount {{amount}}",
      "openSession": "Open",
      "workflow": "Workflow"
    },
    "documentTracking": {
      "title": "Document tracking",
      "description": "Some required documents need your attention. Upload or renew them to stay compliant."
    },
    "leave": {
      "calendarHint": "Click or drag across days to select. Only the days you pick are included — gaps are kept.",
      "scheduledLeave": "Scheduled leave",
      "calculatingLeaveImpact": "Calculating leave impact…"
    },
    "time": {
      "pendingItemsNote": "Pending items are shown separately and count toward approval before they are included in the totals above.",
      "manualSessionOpen": "Manual session open since {{time}}",
      "geoSessionOpen": "Geo session open since {{time}}",
      "geoSessionAlreadyOpen": "You are already checked in. Tap Geo check-out when you leave.",
      "modeGeo": "Geo",
      "modeManual": "Manual"
    },
    "schedule": {
      "rangeDescription": "Expected and resolved schedule for {{start}} to {{end}}"
    },
    "approvals": {
      "returnedForChanges_one": "{{count}} request returned for changes.",
      "returnedForChanges_other": "{{count}} requests returned for changes.",
      "noApprovalRequestsYet": "No approval requests yet."
    },
    "errors": {
      "geoCheckInFailed": "Could not check in — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings.",
      "geoCheckOutFailed": "Could not check out — you may be outside the office area. Allow location access, move closer, or ask HR to verify the attendance location settings."
    },
    "empty": {
      "noOpenAttendanceSession": "No open attendance session",
      "noUpcomingRoster": "No upcoming roster entries — your assigned shift or company calendar applies.",
      "noRosterThisMonth": "No roster entries this month.",
      "noAttendanceRecords": "No attendance records yet.",
      "noLeaveRequests": "No leave requests yet.",
      "noPayslips": "No payslips available yet.",
      "noApprovalRequests": "No approval requests yet.",
      "noOvertimeThisMonth": "No overtime requests this month.",
      "noExpenseClaims": "No expense claims.",
      "noTrainingAssignments": "No training assignments."
    }
  },
  "mss": {
    "loading": "Loading…",
    "stats": {
      "directReports": "Direct reports",
      "pendingLeave": "Pending leave",
      "pendingAttendance": "Pending attendance",
      "myApprovalQueue": "My approval queue"
    },
    "teamHierarchy": {
      "title": "My team hierarchy",
      "hint": "Click an employee to view their record below"
    },
    "record": {
      "viewingAsManager": "Manager view",
      "title": "{{name}}",
      "subtitle": "Same layout as Employee Self-Service for the selected team member.",
      "selectedEmployee": "Selected employee",
      "aria": "Record for {{name}}",
      "emptyTitle": "Select a team member",
      "emptyDescription": "Choose an employee in the hierarchy to see their profile, schedule, time, leave, and pay — without leaving this page.",
      "clear": "Clear selection",
      "loading": "Loading employee record"
    },
    "quickActions": {
      "title": "Quick actions",
      "myApprovals": "My approvals",
      "timeAttendance": "Time & attendance",
      "allEmployees": "All employees"
    },
    "actions": {
      "refresh": "Refresh"
    }
  },
  "hierarchy": {
    "noReportingHierarchy": "No reporting hierarchy",
    "assignManagersToBuild": "Assign managers to build your organization tree.",
    "you": "You",
    "viewOnly": "View only",
    "directReport_one": "{{count}} direct report",
    "directReport_other": "{{count}} direct reports",
    "employeesInTree_one": "{{count}} employee in tree",
    "employeesInTree_other": "{{count}} employees in tree",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "expandAria": "Expand {{name}}",
    "collapseAria": "Collapse {{name}}",
    "orgChart": {
      "title": "Organization chart",
      "description": "Full company reporting tree. You can open full profiles for yourself and your team; managers and peers outside your scope show a limited preview only.",
      "loading": "Loading hierarchy…",
      "empty": "No employees in the reporting tree yet. Assign a manager, or ensure employees are active and linked to this company.",
      "summaryWithViewer": "{{count}} employees · full company chart — you can open profiles for yourself and your team",
      "summaryTopDown": "{{count}} employees · top-down reporting tree"
    },
    "reportingRelationship": {
      "title": "Reporting relationship",
      "description": "Set, change, or remove an employee's direct manager. Choose \"No manager\" to clear an invalid or outdated reporting line.",
      "noManager": "No manager"
    },
    "actions": {
      "employeeDirectory": "Employee directory",
      "orgMasterData": "Org master data"
    },
    "preview": {
      "limitedTitle": "Limited employee preview",
      "managerTitle": "Reporting manager",
      "limitedDescription": "You can see this person in the hierarchy, but full HR profile details are only available for yourself and employees in your reporting line below you.",
      "managerDescription": "This is your direct reporting manager. Full HR profile details are not available from this view."
    },
    "errors": {
      "failedToAssignManager": "Failed to assign manager",
      "failedToRemoveManager": "Failed to remove manager"
    }
  },
  "directory": {
    "loadingEmployees": "Loading employees…",
    "employeesFound_one": "{{count}} employee found",
    "employeesFound_other": "{{count}} employees found",
    "noSearchResults": "No employees match your search",
    "tryDifferentSearch": "Try a different search term.",
    "hierarchySidebarHint": "Everyone in the company is listed. Open full profiles for yourself and your team; others show a limited preview.",
    "detailTabs": {
      "overview": "Overview",
      "details": "Employee details",
      "employment": "Employment",
      "onboarding": "Onboarding",
      "time": "Time & leave",
      "pay": "Pay & performance",
      "documents": "Documents & training"
    },
    "actions": {
      "shifts": "Shifts",
      "timeAttendance": "Time & attendance",
      "overtime": "Overtime",
      "editEmployment": "Edit employment",
      "recordLifecycleEvent": "Record lifecycle event"
    },
    "lifecycle": {
      "noEvents": "No lifecycle events recorded.",
      "present": "present"
    },
    "training": {
      "noRecords": "No training records."
    },
    "assets": {
      "noAssigned": "No assets assigned."
    }
  },
  "overtimePage": {
    "newRequest": "New overtime request",
    "requestsList": "Overtime requests",
    "bulkHint": "Request the same overtime entry for one or more employees.",
    "selectEmployeeForSummary": "Select an employee to see their overall approved overtime for the chosen period.",
    "emptyWithCreate": "Adjust the employee or date range, or submit a new request above.",
    "emptyFilterOnly": "Adjust the employee or date range.",
    "toast": {
      "requested": "Overtime requested",
      "selectEmployee": "Select at least one employee"
    },
    "approval": {
      "cancellationPending": "Cancellation pending approval",
      "cancellationPendingShort": "cancellation pending"
    },
    "summaryDateRange": " · {{from}} to {{to}}",
    "typeModal": {
      "editTitle": "Edit overtime type",
      "newTitle": "New overtime type"
    },
    "attendanceFields": {
      "title": "Overtime",
      "estimatedWithType": "Estimated overtime: {{estimated}} (expected {{expected}}). Select the overtime type before saving.",
      "expectedBeyondSchedule": "Expected hours for this day: {{expected}}. Select an overtime type if the employee worked beyond schedule.",
      "schedulePending": "Expected hours and breaks will be resolved from the employee schedule."
    },
    "modal": {
      "title": "Overtime",
      "titleLeaveDay": "Overtime (leave day)",
      "approved": "Approved {{minutes}}",
      "pendingApproval": "{{minutes}} pending approval"
    }
  },
  "devicesPage": {
    "deviceTypes": {
      "biometric": "Biometric",
      "rfid": "RFID",
      "qr": "QR",
      "face": "Face recognition"
    },
    "noDevices": "No devices registered."
  },
  "compensationPage": {
    "salaryStructures": "Salary structures",
    "assignToEmployee": "Assign to employee",
    "structureFallback": "Structure #{{id}}",
    "selectEmployeeToViewAssignments": "Select an employee to view their salary assignments.",
    "assignmentsForEmployee": "Salary assignments"
  },
  "statutoryPage": {
    "portals": {
      "epfo": {
        "name": "EPFO (ECR)",
        "description": "Employee Provident Fund — monthly ECR upload"
      },
      "esic": {
        "name": "ESIC",
        "description": "Employees' State Insurance contribution filing"
      },
      "traces": {
        "name": "TRACES (TDS)",
        "description": "TDS / Form 24Q reconciliation portal"
      }
    },
    "payrollRunsSection": "Payroll runs — export & auto-file",
    "downloadCsv": "Download CSV",
    "filePortal": "File {{portal}}",
    "refreshStatus": "Refresh status",
    "noPayrollRuns": "No payroll runs yet",
    "filingFailed": "{{portalCode}} filing failed"
  },
  "loansPage": {
    "newLoanRequest": "New loan request",
    "submitRequest": "Submit request"
  },
  "master": {
    "title": "HR master data",
    "description": "Configure HR masters per company — leave, employment, org units, documents, overtime, shifts, and expenses.",
    "add": "Add {{label}}",
    "loadFailed": "Failed to load HR master data",
    "yes": "Yes",
    "no": "No",
    "tabs": {
      "leave": {
        "label": "Leave types",
        "description": "Define leave categories, calendar colors, and accrual policies per company"
      },
      "employment": {
        "label": "Employment types",
        "description": "Contract types used when hiring and changing employment"
      },
      "documents": {
        "label": "Document types",
        "description": "Categories for employee document uploads and expiry tracking"
      },
      "businessUnits": {
        "label": "Business units",
        "description": "Top-level divisions used to group departments and reporting"
      },
      "departments": {
        "label": "Departments",
        "description": "Functional teams employees belong to — optional parent and business unit"
      },
      "grades": {
        "label": "Grades",
        "description": "Job levels for compensation bands and designation mapping"
      },
      "designations": {
        "label": "Designations",
        "description": "Job titles linked to a department and grade"
      },
      "overtime": {
        "label": "Overtime types",
        "description": "Classify overtime by calendar context — each company defines its own"
      },
      "shiftTypes": {
        "label": "Shift types",
        "description": "Categories for shift definitions (fixed, flexible, rotational, etc.)"
      },
      "shifts": {
        "label": "Shift definitions",
        "description": "Named shifts with hours and calendar colors for employee assignment"
      },
      "expenseTypes": {
        "label": "Expense types",
        "description": "Categories for employee expense claims and reimbursements"
      },
      "assetTypes": {
        "label": "Asset types",
        "description": "Equipment categories employees can request — laptop, phone, monitor, etc."
      },
      "assetRequests": {
        "label": "Asset requests",
        "description": "Submit and track employee equipment requests with approval workflow"
      },
      "pipelineStages": {
        "label": "Pipeline stages",
        "description": "Recruitment kanban columns — name, order, and color per company"
      },
      "pipelines": {
        "label": "Recruitment pipelines",
        "description": "Named pipelines with stage order and allowed transitions"
      },
      "formFields": {
        "label": "Form fields",
        "description": "Custom application and ATS form field definitions by scope"
      },
      "recruitmentSettings": {
        "label": "Recruitment settings",
        "description": "Pipelines, custom fields, screening, interviews, offers, notifications, and policies"
      }
    },
    "payrollMode": {
      "monthlySalary": "Monthly salary",
      "hourly": "Hourly",
      "contractRules": "Contract rules"
    },
    "dayClass": {
      "any": "Any day",
      "working": "Scheduled working day",
      "holiday": "Holiday",
      "weekend": "Weekend / off day"
    },
    "shifts": {
      "title": "Shift definitions",
      "description": "Named shifts with type, hours, and calendar color — used when assigning employees on the Shifts page.",
      "versioningHint": "The list always shows today's hours. Edits with a future effective date are scheduled and appear as a second line until that date.",
      "shiftName": "Shift name",
      "startTime": "Start time",
      "endTime": "End time",
      "calendarColor": "Calendar color",
      "createShift": "Create shift",
      "breaksColumn": "Breaks",
      "currentHoursLabel": "Currently effective (today): {{hours}}",
      "effectiveFromHint": "Choose when the new hours and lunch break should start. Until that date, today's hours stay unchanged.",
      "editingScheduledHint": "A change is already scheduled from {{date}}. You are editing that scheduled version.",
      "scheduledFromLabel": "From {{date}}: {{hours}}",
      "scheduledBreaksLabel": "From then: {{breaks}}",
      "scheduledUpdateToast": "Shift update scheduled from {{date}} ({{hours}}). Today's list still shows current hours until then.",
      "empty": "No shifts yet — create one above",
      "loadFailed": "Failed to load shifts",
      "createFailed": "Create shift failed",
      "deactivateFailed": "Failed to deactivate shift",
      "activateFailed": "Failed to activate shift"
    },
    "leavePolicy": {
      "saved": "Leave policy saved — employee balances updated from policy entitlement",
      "saveFailed": "Failed to save policy"
    },
    "modals": {
      "leaveType": {
        "edit": "Edit leave type",
        "new": "New leave type"
      },
      "employmentType": {
        "edit": "Edit employment type",
        "new": "New employment type"
      },
      "documentType": {
        "edit": "Edit document type",
        "new": "New document type"
      },
      "shiftType": {
        "edit": "Edit shift type",
        "new": "New shift type"
      },
      "expenseType": {
        "edit": "Edit expense type",
        "new": "New expense type"
      },
      "assetType": {
        "edit": "Edit asset type",
        "new": "New asset type"
      },
      "pipelineStage": {
        "edit": "Edit pipeline stage",
        "new": "New pipeline stage"
      },
      "calendarColor": "Calendar color",
      "calendarColorHint": "Used on the time & attendance calendar and leave lists.",
      "documentExpiryYes": "Yes — require ID, name, expiry & file",
      "pipelineStageCodeLocked": "Stage name and code are permanent after creation. Only the color can be changed."
    },
    "leavePolicyPanel": {
      "title": "Leave policies",
      "description": "Paid leave types require a policy. Unpaid leave is unlimited unless you configure a policy to cap days or add rules. Entitlement changes update employee balances automatically.",
      "configurePolicy": "Configure policy",
      "editTitle": "Edit leave policy",
      "configureTitle": "Configure leave policy",
      "optional": "Optional",
      "required": "Required",
      "notRequired": "Not required",
      "annualEntitlementHint": "Total days per year — changing this updates all employee balances",
      "backdatedNo": "No — start date must be today or future",
      "backdatedYes": "Yes — employees may apply for past dates",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "accrual": {
        "none": "No accrual",
        "monthly": "Monthly",
        "yearly": "Yearly (lump)",
        "monthlyWithDays": "Monthly ({{days}}d)",
        "yearlyLump": "Yearly lump"
      },
      "backdated": {
        "no": "No",
        "yesAny": "Yes (any past date)",
        "yesUpTo": "Yes (up to {{days}} days)"
      },
      "defaultPolicyName": "{{name}} policy"
    },
    "orgMaster": {
      "gradesHintBefore": "Set up",
      "gradesHintLink": "grades",
      "gradesHintAfter": "before designations so titles inherit the correct level.",
      "modals": {
        "businessUnit": {
          "edit": "Edit business unit",
          "add": "Add business unit"
        },
        "department": {
          "edit": "Edit department",
          "add": "Add department"
        },
        "grade": {
          "edit": "Edit grade",
          "add": "Add grade"
        },
        "designation": {
          "edit": "Edit designation",
          "add": "Add designation"
        }
      },
      "createFailed": "Failed to create {{entity}}"
    },
    "toast": {
      "leaveTypeDeactivated": "Leave type deactivated",
      "leaveTypeActivated": "Leave type activated",
      "leaveTypeUpdated": "Leave type updated",
      "leaveTypeCreated": "Leave type created",
      "employmentTypeDeactivated": "Employment type deactivated",
      "employmentTypeActivated": "Employment type activated",
      "employmentTypeUpdated": "Employment type updated",
      "employmentTypeCreated": "Employment type created",
      "documentTypeDeactivated": "Document type deactivated",
      "documentTypeActivated": "Document type activated",
      "documentTypeUpdated": "Document type updated",
      "documentTypeCreated": "Document type created",
      "overtimeTypeDeactivated": "Overtime type deactivated",
      "overtimeTypeActivated": "Overtime type activated",
      "overtimeTypeUpdated": "Overtime type updated",
      "overtimeTypeCreated": "Overtime type created",
      "shiftTypeDeactivated": "Shift type deactivated",
      "shiftTypeActivated": "Shift type activated",
      "shiftTypeUpdated": "Shift type updated",
      "shiftTypeCreated": "Shift type created",
      "shiftCreated": "Shift created",
      "shiftDeactivated": "Shift deactivated",
      "shiftActivated": "Shift activated",
      "expenseTypeDeactivated": "Expense type deactivated",
      "expenseTypeActivated": "Expense type activated",
      "expenseTypeUpdated": "Expense type updated",
      "expenseTypeCreated": "Expense type created",
      "assetTypeDeactivated": "Asset type deactivated",
      "assetTypeActivated": "Asset type activated",
      "assetTypeUpdated": "Asset type updated",
      "assetTypeCreated": "Asset type created",
      "pipelineStageUpdated": "Pipeline stage updated",
      "pipelineStageCreated": "Pipeline stage created",
      "businessUnitActivated": "Business unit activated",
      "businessUnitDeactivated": "Business unit deactivated",
      "businessUnitUpdated": "Business unit updated",
      "businessUnitCreated": "Business unit created",
      "departmentActivated": "Department activated",
      "departmentDeactivated": "Department deactivated",
      "departmentUpdated": "Department updated",
      "departmentCreated": "Department created",
      "gradeActivated": "Grade activated",
      "gradeDeactivated": "Grade deactivated",
      "gradeUpdated": "Grade updated",
      "gradeCreated": "Grade created",
      "designationActivated": "Designation activated",
      "designationDeactivated": "Designation deactivated",
      "designationUpdated": "Designation updated",
      "designationCreated": "Designation created"
    },
    "errors": {
      "nameCodeRequired": "Name and code are required",
      "shiftNameTypeRequired": "Shift name and type are required",
      "deactivateLeaveType": "Failed to deactivate leave type",
      "activateLeaveType": "Failed to activate leave type",
      "deactivateEmploymentType": "Failed to deactivate employment type",
      "activateEmploymentType": "Failed to activate employment type",
      "deactivateDocumentType": "Failed to deactivate document type",
      "activateDocumentType": "Failed to activate document type",
      "deactivateOvertimeType": "Failed to deactivate overtime type",
      "activateOvertimeType": "Failed to activate overtime type",
      "deactivateShiftType": "Failed to deactivate shift type",
      "activateShiftType": "Failed to activate shift type",
      "deactivateExpenseType": "Failed to deactivate expense type",
      "activateExpenseType": "Failed to activate expense type",
      "deactivateAssetType": "Failed to deactivate asset type",
      "activateAssetType": "Failed to activate asset type"
    },
    "recruitmentSettings": {
      "tabs": {
        "pipelines": {
          "label": "Pipelines"
        },
        "fields": {
          "label": "Custom fields"
        },
        "screening": {
          "label": "Screening questions"
        },
        "interviews": {
          "label": "Interview criteria / templates"
        },
        "offers": {
          "label": "Offer templates"
        },
        "notifications": {
          "label": "Notification templates"
        },
        "bgv": {
          "label": "Background verification (BGV)"
        },
        "assessments": {
          "label": "Assessment Master"
        }
      },
      "placeholders": {
        "selectJob": "Select a job"
      },
      "bgv": {
        "toast": {
          "updated": "Background verification setting updated",
          "created": "Background verification setting created",
          "deleted": "Setting deleted"
        },
        "placeholders": {
          "code": "e.g. IDENTITY, CHECKR",
          "label": "e.g. Identity Check, Checkr API"
        },
        "columns": {
          "category": "Category",
          "code": "Code",
          "label": "Label",
          "description": "Description",
          "sortOrder": "Sort order",
          "status": "Status",
          "actions": "Actions"
        }
      },
      "screening": {
        "toast": {
          "updated": "Screening question updated",
          "created": "Screening question created"
        },
        "errors": {
          "minOptions": "Add at least two answer options."
        },
        "columns": {
          "order": "Order",
          "question": "Question",
          "type": "Type",
          "required": "Required",
          "weight": "Weight",
          "status": "Status"
        }
      },
      "interviews": {
        "columns": {
          "order": "Order",
          "code": "Code",
          "criterion": "Criterion",
          "status": "Status"
        }
      },
      "notifications": {
        "placeholders": {
          "language": "en_US"
        },
        "columns": {
          "event": "Recruitment event",
          "template": "Template",
          "channel": "Channel",
          "language": "Language",
          "status": "Status"
        },
        "published": "Published · v{{n}}",
        "draft": "Draft · v{{n}}"
      },
      "assessments": {
        "toast": {
          "updated": "Assessment master item updated",
          "created": "Assessment master item created",
          "deleted": "Assessment master item deleted"
        },
        "placeholders": {
          "code": "e.g. TECHNICAL, CODING",
          "type": "e.g. Technical test, Coding test",
          "name": "e.g. Technical assessment",
          "provider": "e.g. HackerRank / Codility",
          "url": "https://...",
          "description": "Details about this assessment type..."
        },
        "columns": {
          "code": "Code",
          "type": "Assessment Type",
          "name": "Default Assessment Name",
          "description": "Description / Provider",
          "passMark": "Pass Mark",
          "sortOrder": "Sort order",
          "status": "Status",
          "actions": "Actions"
        }
      },
      "offers": {
        "toast": {
          "updated": "Offer template updated",
          "created": "Offer template created",
          "deleted": "Offer template deleted"
        },
        "columns": {
          "name": "Name",
          "code": "Code",
          "status": "Status"
        }
      }
    },
    "formFields": {
      "toast": {
        "deleted": "Field deleted",
        "updated": "Field updated",
        "created": "Field created"
      },
      "columns": {
        "code": "Code",
        "label": "Label",
        "type": "Type",
        "options": "Options",
        "required": "Required",
        "section": "Section",
        "status": "Status"
      }
    },
    "pipelines": {
      "toast": {
        "defaultUpdated": "Default pipeline updated",
        "created": "Pipeline created",
        "colorUpdated": "Stage color updated",
        "stageAdded": "Stage added",
        "orderUpdated": "Stage order updated",
        "transitionsUpdated": "Transitions updated"
      },
      "errors": {
        "invalidTransition": "Each transition needs different source and destination stages plus an action code"
      },
      "placeholders": {
        "actionCode": "MOVE_TO_STAGE",
        "stageType": "SCREENING"
      },
      "columns": {
        "code": "Code",
        "name": "Name",
        "default": "Default",
        "active": "Active",
        "version": "Version"
      }
    }
  },
  "recruitment": {
    "title": "Recruitment",
    "loadDashboardFailed": "Failed to load recruitment dashboard",
    "workQueueTitle": "Recruitment work queue",
    "tabs": {
      "tracking": {
        "label": "Tracking",
        "hint": "Server-filtered candidate tracking in Kanban, list, or timeline view"
      },
      "dashboard": {
        "label": "Dashboard",
        "hint": "Live hiring metrics, funnel, and analytics"
      },
      "interviews": {
        "label": "Interviews",
        "hint": "Calendar, assigned interviews, pending feedback, and completed rounds"
      },
      "planning": {
        "label": "Workforce planning",
        "hint": "Headcount requests — after approval, convert to a job requisition"
      },
      "requisitions": {
        "label": "Requisitions",
        "hint": "Approved positions to fill (from manpower or created directly)"
      },
      "jobs": {
        "label": "Job postings",
        "hint": "Open roles candidates apply to"
      },
      "pipeline": {
        "label": "Pipeline",
        "hint": "Candidate kanban by stage"
      },
      "talentpool": {
        "label": "Talent pool",
        "hint": "Saved candidates ready to re-engage"
      },
      "templates": {
        "label": "Offer templates",
        "hint": "Reusable offer letter templates"
      }
    },
    "tracking": {
      "view": "Tracking view",
      "views": {
        "kanban": "Kanban",
        "list": "List",
        "timeline": "Timeline"
      },
      "apply": "Apply filters",
      "clear": "Clear",
      "loading": "Loading candidates…",
      "empty": "No candidates match these filters",
      "error": "Recruitment tracking could not be loaded.",
      "kanbanBound": "Showing the first {{count}} of {{total}} matching candidates. Narrow the filters to focus the board.",
      "columns": {
        "candidate": "Candidate",
        "job": "Job",
        "stage": "Stage",
        "recruiter": "Recruiter",
        "manager": "Hiring manager",
        "interview": "Nearest interview",
        "aging": "Aging",
        "priority": "Priority",
        "updated": "Last updated"
      },
      "filters": {
        "candidate": "Candidate / person / ID",
        "pipeline": "Pipeline",
        "job": "Job",
        "requisition": "Requisition",
        "stage": "Stage code",
        "recruiter": "Recruiter employee ID",
        "manager": "Hiring manager employee ID",
        "department": "Department ID",
        "location": "Location",
        "employmentType": "Employment type",
        "source": "Source",
        "priority": "Priority",
        "dateFrom": "Applied from",
        "dateTo": "Applied to",
        "minAging": "Minimum aging (days)",
        "maxAging": "Maximum aging (days)",
        "customCode": "Custom field code",
        "customValue": "Custom field value",
        "stagePlaceholder": "APL, SCR, IVS…"
      }
    },
    "interviews": {
      "sections": {
        "all": "All",
        "mine": "My interviews",
        "feedback": "Pending feedback",
        "upcoming": "Upcoming",
        "completed": "Completed"
      },
      "views": {
        "calendar": "Calendar",
        "list": "List"
      },
      "filters": {
        "from": "From",
        "to": "To",
        "status": "Status"
      },
      "columns": {
        "date": "Date and time",
        "candidate": "Candidate",
        "job": "Job",
        "round": "Round",
        "interviewers": "Interviewers",
        "status": "Status",
        "location": "Location / link"
      },
      "join": "Open interview",
      "pendingFeedback": "Your feedback is pending",
      "loading": "Loading interviews…",
      "empty": "No interviews match these filters",
      "error": "Interviews could not be loaded."
    },
    "jobs": {
      "edit": "Edit",
      "editPosting": "Edit job posting",
      "publish": "Publish",
      "published": "Job published",
      "publishFailed": "Failed to publish job",
      "copyLink": "Copy link",
      "linkCopied": "Careers link copied",
      "copyUnavailable": "Clipboard access is unavailable",
      "linkUnavailable": "Link unavailable",
      "updated": "Job posting updated",
      "postingChannels": "Posting channels",
      "internalOnly": "Internal only",
      "applicationFields": "Application fields",
      "applicationFieldsHint": "Name, email, and phone are always required. Choose the other fields candidates must complete.",
      "include": "Include",
      "required": "Required",
      "remove": "Remove",
      "customFieldLabel": "Custom field label",
      "fieldType": "Field type",
      "addCustomField": "Add custom field",
      "fieldTypes": {
        "text": "Text",
        "textarea": "Long text",
        "number": "Number",
        "date": "Date",
        "datetime": "Date & time",
        "time": "Time",
        "email": "Email",
        "phone": "Phone",
        "url": "URL / link",
        "dropdown": "Dropdown",
        "radio": "Radio buttons",
        "multiselect": "Multi-select",
        "checkbox": "Checkbox",
        "file": "File upload"
      },
      "fieldOptions": "Options",
      "fieldOptionsHint": "One option per line (required for dropdown, radio, multi-select)",
      "fieldOptionsListHint": "Add each choice as a separate option. Candidates will see these on the application form.",
      "noOptionsYet": "No options yet — add at least one choice below.",
      "newOption": "New option",
      "newOptionPlaceholder": "e.g. Full-time",
      "addOption": "Add option",
      "optionN": "Option {{n}}",
      "moveOptionUp": "Move up",
      "moveOptionDown": "Move down",
      "optionsRequired": "Add at least one option for this field type",
      "placeholder": "Placeholder",
      "placeholderHint": "Optional hint text shown inside the field",
      "defaultChecked": "Checked by default",
      "fileFieldHint": "Candidates can upload a file (PDF, DOC, image). The file URL is stored with the application.",
      "livePreview": "Live preview",
      "previewLabel": "Field label",
      "typeHints": {
        "date": "Candidates pick a calendar date.",
        "datetime": "Candidates pick a date and time.",
        "time": "Candidates pick a time of day."
      },
      "placeholders": {
        "postingChannels": "CAREER_PORTAL,LINKEDIN"
      }
    },
    "candidate": {
      "applicationDetails": "Application details",
      "viewResume": "View resume",
      "viewDocument": "View document",
      "jobApplied": "Job applied for",
      "source": "Application source",
      "screeningAnswers": "Screening questions",
      "screeningQuestion": "Question #{{id}}",
      "screeningScore": "Score: {{score}}",
      "uploadedDocuments": "Uploaded documents",
      "workspace": {
        "overview": "Overview",
        "application": "Application",
        "screening": "Screening",
        "assessment": "Assessment",
        "interviews": "Interviews",
        "selection": "Selection",
        "offer": "Offer",
        "preboarding": "Preboarding",
        "timeline": "Timeline",
        "nextAction": "Next action",
        "noAction": "No action required",
        "recruiter": "Recruiter",
        "hiringManager": "Hiring manager"
      },
      "hireProfile": {
        "candidateTitle": "Candidate details",
        "candidateHint": "These required fields are filled by the candidate in the candidate portal.",
        "candidatePending": "Waiting for the candidate to complete personal details in the portal.",
        "candidateComplete": "Candidate personal details submitted",
        "hrTitle": "Fields HR must complete",
        "hrHint": "Complete job, contract and salary details so they are stored on the employee record at hire.",
        "hrComplete": "Job and contract details saved",
        "hrPending": "Job, contract and salary details still need to be completed.",
        "saveHr": "Save employee details",
        "saved": "Employee details saved for hire",
        "saveError": "Could not save employee details",
        "incompleteHire": "Candidate personal details and HR job/contract details must be complete before hire."
      },
      "toast": {
        "offerCreated": "Offer created and submitted for approval",
        "assessmentsComplete": "All scheduled assessments have already been completed.",
        "offerRevisionCreated": "Offer revision created and submitted for approval",
        "preboardingItemCompleted": "Preboarding item completed",
        "documentUploaded": "Document uploaded",
        "documentRemoved": "Document removed",
        "onboardingTaskCompleted": "Onboarding task \"{{taskLabel}}\" completed",
        "taskReopened": "Task \"{{taskLabel}}\" reopened for revision",
        "selectionRequired": "Selection required for: {{tasks}}",
        "onboardingTasksCompleted": "Completed {{count}} onboarding task(s)",
        "bgvInitiated": "Background verification initiated",
        "screeningOverridden": "Screening decision overridden",
        "reconsidered": "Candidate reconsidered and restored to active pipeline",
        "offerEmailed": "Offer emailed to candidate with portal link to accept or decline",
        "bgvCleared": "Background verification checks completed and cleared",
        "stageUpdated": "Candidate stage updated",
        "offerWithdrawn": "Offer withdrawn",
        "portalLinkCopied": "Candidate portal link copied to clipboard",
        "reminderQueued": "Reminder queued",
        "reminderSent": "Candidate reminder sent",
        "bgvRestarted": "Background verification restarted",
        "selectionSubmitted": "Selection submitted for approval",
        "interviewRescheduled": "Interview rescheduled successfully",
        "interviewCancelled": "Interview cancelled",
        "customMessage": "Custom message"
      },
      "errors": {
        "declineReasonRequired": "Select or enter a decline reason",
        "selectionReasonRequired": "Selection reason is required"
      },
      "placeholders": {
        "businessUnit": "Select Business Unit from Master...",
        "department": "Select Department / Team from Master...",
        "designation": "Select Designation from Master...",
        "manager": "Select Manager / Employee from Master...",
        "shift": "Select Work Schedule / Shift from Master...",
        "assets": "Select Onboarding Assets from Master...",
        "training": "Select Training Course from Master...",
        "documentType": "Select Document Type from Master...",
        "grade": "Select Grade / Payroll Structure from Master...",
        "hours": "Hours (e.g. 40)",
        "workEmail": "Work Email (e.g. user@company.com)",
        "notes": "Enter assignment / notes...",
        "bgvTypeLoading": "Loading check types...",
        "bgvType": "Select verification type...",
        "bgvVendorLoading": "Loading vendor options...",
        "bgvVendor": "Select vendor...",
        "overrideReason": "Explain why the automatic decision should be overridden.",
        "scoreExample": "e.g. 85",
        "evaluationRemarks": "Enter evaluation remarks or marks breakdown...",
        "assessmentTypeLoading": "Loading assessment types...",
        "assessmentType": "Select type...",
        "externalProvider": "HackerRank / Codility / ...",
        "externalUrl": "https://...",
        "declineReason": "Compensation, timing, accepted another offer…",
        "selectionReason": "e.g. Excellent technical performance...",
        "rescheduleReason": "e.g. Candidate requested date shift...",
        "cancelReason": "e.g. Candidate withdrew application...",
        "reconsiderReason": "e.g. Position reopened..."
      },
      "salaryPeriod": {
        "DAY": "Per Day",
        "WEEK": "Per Week",
        "MONTH": "Per Month",
        "YEAR": "Per Year"
      },
      "recommendations": {
        "STRONG_HIRE": "Strong hire",
        "HIRE": "Hire",
        "HOLD": "Hold",
        "NO_HIRE": "No hire"
      },
      "assessmentResult": {
        "AUTO": "Auto (from pass threshold)",
        "PASSED": "Passed",
        "FAILED": "Failed"
      },
      "restoreStages": {
        "SEL": "Selected / Offer Stage (SEL)",
        "IVD": "Interviewed (IVD)",
        "SCR": "Screened (SCR)",
        "APL": "Applied (APL)"
      },
      "timeline": {
        "allActivity": "All activity"
      }
    },
    "talentPool": {
      "badge": "Talent pool",
      "aboutTitle": "What is the talent pool?",
      "aboutDescription": "A holding area for strong non-selected candidates (rejected/silver medalists) and shortlisted candidates. Hired employees are automatically excluded as they become active staff.",
      "flowSave": "Save — From a candidate profile, choose “Move to talent pool” (for non-selected or shortlisted candidates).",
      "flowBrowse": "Browse — Filter saved candidates by Non-Selected, Selected/Shortlisted, or Active status.",
      "flowReengage": "Re-engage — When a role opens, pick a job posting and return the candidate to Applied or Screening in the pipeline.",
      "totalSaved": "Saved candidates",
      "nonSelectedCount": "Non-selected candidates",
      "selectedCount": "Selected / Shortlisted",
      "matchingSearch": "Matching filters",
      "search": "Search",
      "searchPlaceholder": "Name, email, skills, or job…",
      "filterCategory": "Category",
      "allCategories": "All Categories",
      "categoryNonSelected": "Non-Selected / Rejected",
      "categorySelected": "Selected / Shortlisted",
      "categoryActive": "Active Pipeline",
      "filterSource": "Source",
      "allSources": "All sources",
      "clearFilters": "Clear filters",
      "previousRole": "Previous role",
      "lastStage": "Last stage",
      "experience": "Experience",
      "screening": "Screening score",
      "savedOn": "Saved on",
      "viewProfile": "View profile",
      "reengage": "Re-engage",
      "reengageModalTitle": "Re-engage {{name}}",
      "reengageHint": "The candidate returns to the active pipeline. Choose which job and starting stage to use.",
      "targetJob": "Job posting",
      "keepPreviousJob": "Keep previous job posting",
      "startStage": "Start at stage",
      "reengageConfirm": "Re-engage into pipeline",
      "reengaged": "Candidate re-engaged into the pipeline",
      "reengageFailed": "Failed to re-engage candidate",
      "emptyTitle": "No saved candidates yet",
      "emptyDescription": "When someone is a non-selected candidate (e.g. rejected silver medalist) or shortlisted fit, open their profile and choose “Move to talent pool”.",
      "loadFailed": "Failed to load talent pool",
      "moveToPool": "Move to talent pool",
      "moveModalTitle": "Save {{name}} for later?",
      "moveHint": "The candidate will be removed from the active pipeline but kept in the talent pool. You can re-engage them when a suitable role opens.",
      "moveNote": "Note (optional)",
      "moveNotePlaceholder": "e.g. Non-selected silver medalist — revisit when senior role opens",
      "moveConfirm": "Save to talent pool",
      "moved": "Candidate saved to talent pool",
      "moveFailed": "Failed to move candidate to talent pool",
      "hiredCannotBeSaved": "Hired candidates cannot be moved to the talent pool because they are active employees.",
      "candidatePausedHint": "This candidate is paused in the talent pool. Re-engage them to continue hiring for an open role.",
      "stages": {
        "screening": "Screening",
        "applied": "Applied"
      }
    },
    "pipeline": {
      "dragHint": "Drag a candidate to the next stage. A form opens before the move is saved — cancel to keep the current stage.",
      "clickHint": "Click a candidate to open the hiring workflow panel.",
      "noSearchResults": "No candidates match your search.",
      "modal": {
        "scheduleAssessment": "Schedule assessment — {{name}}",
        "scheduleInterview": "Schedule interview — {{name}}",
        "completeInterview": "Complete interview — {{name}}",
        "createOffer": "Create offer — {{name}}",
        "acceptOffer": "Accept offer — {{name}}",
        "reject": "Reject candidate — {{name}}",
        "declineOffer": "Decline offer — {{name}}",
        "completePreboarding": "Complete preboarding — {{name}}",
        "completeOnboarding": "Complete onboarding — {{name}}",
        "moveTo": "Move {{name}} to {{stage}}",
        "confirmAssessment": "Schedule & move",
        "confirmMove": "Move candidate",
        "confirmAccept": "Accept offer",
        "confirmReject": "Reject",
        "confirmDecline": "Decline offer",
        "confirmPreboarding": "Complete preboarding",
        "confirmOnboarding": "Complete onboarding",
        "confirmMoveHint": "The candidate will move to {{stage}} after you confirm.",
        "acceptOfferHint": "Accept the sent offer on behalf of the candidate. Preboarding starts automatically.",
        "declineOfferHint": "Mark the offer as declined. The candidate stays in the hiring workflow.",
        "completePreboardingHint": "Mark all preboarding checklist items complete and advance to onboarding.",
        "completeOnboardingHint": "Complete onboarding tasks and approve before hire.",
        "rejectReason": "Rejection notes (optional)",
        "rejectReasonPlaceholder": "Reason for rejection…",
        "externalProvider": "HackerRank / Codility / ...",
        "declineReason": "Compensation, timing, accepted another offer…",
        "selectRejectionCategory": "-- Select Rejection Category --"
      },
      "toast": {
        "moved": "Candidate moved to {{stage}}",
        "rejected": "Candidate rejected"
      },
      "errors": {
        "invalidTransition": "That stage change is not allowed from the current step.",
        "transitionFailed": "Stage change failed — the candidate remains in the current stage.",
        "noScheduledInterview": "No scheduled interview found. Schedule an interview first.",
        "noSentOffer": "No sent offer found for this candidate.",
        "rejectionRequired": "Please select a rejection category or provide a rejection reason",
        "declineReasonRequired": "Decline reason is required"
      }
    },
    "stageHistory": {
      "empty": "No stage changes recorded yet.",
      "count": "{{count}} events",
      "byName": "By {{name}}",
      "system": "System",
      "userRef": "User #{{id}}",
      "created": "Application started — {{stage}}",
      "movedTo": "Moved to {{stage}}",
      "updatedAt": "Updated at {{stage}}"
    },
    "hiringProgress": {
      "title": "Hiring progress",
      "terminalStage": "Terminal stage: {{stage}}",
      "steps": {
        "screening": "Screening",
        "assessment": "Assessment",
        "interview": "Interview",
        "selection": "Selection",
        "offer": "Offer",
        "acceptance": "Acceptance",
        "preboarding": "Preboarding",
        "onboarding": "Onboarding",
        "hire": "Employee"
      },
      "hints": {
        "terminal": "This candidate is no longer in the active hiring flow.",
        "applied": "Next: Run auto screening to score the candidate against the job.",
        "screening": "Next: Schedule an assessment (optional), or skip ahead and schedule an interview.",
        "assessmentScheduled": "Next: Record the assessment score, then schedule an interview.",
        "assessmentComplete": "Next: Schedule an interview with the candidate.",
        "interviewScheduled": "Next: Complete the interview to move the candidate to Selected.",
        "interviewed": "Next: Create and send the offer letter.",
        "selectionPending": "Next: Approve selection, then create the offer letter.",
        "selected": "Next: Create and send the offer letter.",
        "offerPending": "Next: Approve the offer, then accept on behalf of the candidate or share the portal link.",
        "offerSent": "Next: Accept the offer to start preboarding and background verification.",
        "preboarding": "Next: Complete preboarding checklist and BGV — onboarding starts automatically.",
        "offerAccepted": "Next: Complete preboarding documents in the candidate portal.",
        "onboarding": "Next: Complete onboarding tasks, approve onboarding, then create the employee record.",
        "hired": "Employee created — complete probation review when due.",
        "default": "Continue the hiring workflow."
      }
    },
    "errors": {
      "titleEmploymentRequired": "Title and employment type are required",
      "candidateNameRequired": "Candidate name is required",
      "titleRequired": "Title is required",
      "interviewDateRequired": "Interview date and time are required",
      "employmentTypeRequired": "Employment type is required",
      "possibleDuplicate": "Possible duplicate: {{name}}",
      "loadCandidateFailed": "Failed to load candidate",
      "hireFailed": "Hire failed — complete offer, preboarding, and onboarding first",
      "selectInterviewer": "Select at least one interviewer"
    },
    "inactiveUntilApproved": "Inactive",
    "manpowerInactiveHint": "Draft and pending requests stay inactive until approved through the configured workflow. Only workflow assignees can approve. Assignees and the requester are notified on submit, approve, and reject.",
    "requisitionInactiveHint": "Draft and pending requisitions stay inactive until approved through the configured JOB_REQUISITION workflow. Only workflow assignees can approve. Managers see their own and subordinates' requisitions; subordinates cannot see managers' records.",
    "requester": "Requester",
    "searchManpowerPlaceholder": "Search title, location, or project",
    "createdFrom": "Created from",
    "createdTo": "Created to",
    "planningAnalyticsTitle": "Workforce planning summary",
    "currentHeadcount": "Current headcount",
    "approvedPositions": "Approved positions",
    "openApprovedPositions": "Open approved (no requisition)",
    "pendingPositions": "Pending positions",
    "draftPositions": "Draft positions",
    "approvedBudget": "Approved budget",
    "pendingBudget": "Pending budget",
    "headcountGap": "Projected headcount",
    "headcountGapHint": "Current + open approved positions",
    "departmentGapTitle": "By department",
    "planned": "Planned",
    "approved": "Approved",
    "pending": "Pending",
    "toast": {
      "submittedForApproval": "Submitted for approval",
      "jobPostingCreated": "Job posting created",
      "jobPostingReady": "Job posting ready — open roles are listed under Job postings",
      "requisitionCreated": "Requisition created — submit for approval from the table",
      "requisitionFromManpower": "Requisition created from manpower — submit for approval from the Requisitions tab",
      "requisitionSubmitted": "Requisition submitted for approval",
      "requisitionDraftSaved": "Requisition saved as draft (inactive until approved)",
      "requisitionCancelled": "Requisition cancelled",
      "requisitionDeleted": "Requisition deleted",
      "candidateAdded": "Candidate added",
      "manpowerSubmitted": "Manpower request submitted for approval",
      "manpowerDraftSaved": "Manpower request saved as draft (inactive until approved)",
      "manpowerCancelled": "Manpower request cancelled",
      "manpowerDeleted": "Manpower request deleted",
      "employeeCreated": "Employee #{{id}} created",
      "alreadyHired": "Already hired as employee #{{id}}",
      "interviewScheduled": "Interview scheduled",
      "interviewCompleted": "Interview completed — candidate selected",
      "offerCreated": "Offer created — pending approval before acceptance",
      "assessmentRecorded": "Assessment score recorded — schedule an interview next",
      "assessmentScheduled": "Assessment scheduled — record the score when ready",
      "offerAccepted": "Offer accepted — preboarding started",
      "offerDeclined": "Offer declined",
      "preboardingComplete": "Preboarding complete — moved to onboarding",
      "onboardingApproved": "Onboarding approved — ready to hire",
      "selectionApproved": "Selection approved — you can create the offer",
      "offerApproved": "Offer approved — ready to accept",
      "autoScreeningCompleted": "Auto screening completed",
      "probationConfirmed": "Probation confirmed",
      "probationExtended": "Probation extended",
      "bgvCompleted": "BGV completed"
    },
    "labels": {
      "unassigned": "Unassigned"
    },
    "priority": {
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "URGENT": "Urgent"
    },
    "formFields": {
      "selectPlaceholder": "Select…"
    }
  },
  "careers": {
    "brand": "Careers",
    "title": "Open positions",
    "subtitle": "Browse openings and apply online.",
    "applicationTitle": "Job application",
    "applicationSubtitle": "Review the role and complete the application form.",
    "refresh": "Refresh",
    "loading": "Loading openings…",
    "openingsHeading": "Current openings",
    "openingsCount": "{{count}} role(s) available",
    "emptyTitle": "No open positions right now",
    "apply": "Apply",
    "applying": "Applying",
    "remote": "Remote",
    "opening": "opening",
    "openings": "openings",
    "readMore": "Read more",
    "showLess": "Show less",
    "noDescription": "No job description provided.",
    "applySection": "Application",
    "personalDetails": "Personal details",
    "personalDetailsHint": "Tell us how to reach you and a bit about your background.",
    "additionalFields": "Additional information",
    "additionalFieldsHint": "Complete the information requested specifically for this role.",
    "screeningQuestions": "Screening questions",
    "resume": "Resume",
    "resumeHint": "PDF, DOC, DOCX, TXT, or image — max size per your organization policy.",
    "uploading": "Uploading…",
    "attached": "Attached: {{name}}",
    "resumeUploaded": "Resume uploaded",
    "cancel": "Cancel",
    "thankYouTitle": "Application submitted",
    "thankYouBody": "Thanks for applying. Our recruiting team will review your profile.",
    "applyAgain": "Submit another application",
    "backToOpenings": "Back to openings",
    "jobClosed": "This job posting is closed or no longer accepting applications.",
    "jobUnavailableTitle": "Job no longer available",
    "loadingApplication": "Loading job application…",
    "loadingApplicationForm": "Loading application fields…",
    "formUnavailableTitle": "Application form unavailable",
    "formUnavailableBody": "We could not load the application fields for this role. Return to openings and try again.",
    "fields": {
      "skills": "Skills",
      "skillsPlaceholder": "Java, React, SQL",
      "experienceYears": "Experience (years)",
      "expectedSalary": "Expected salary",
      "education": "Education",
      "linkedinUrl": "LinkedIn URL"
    },
    "errors": {
      "nameEmailRequired": "Full name, email, and phone number are required",
      "requiredField": "{{field}} is required",
      "formLoadFailed": "Failed to load the application form",
      "resumeUploadFailed": "Failed to upload resume"
    },
    "searchPlaceholder": "Search by job title, location, keywords or department...",
    "portal": {
      "errors": {
        "invalidDocumentId": "Invalid preboarding document item ID",
        "missingDocuments": "Please upload all required documents ({{labels}}) before submitting.",
        "missingFields": "Please fill in all required fields for ({{labels}}) before submitting.",
        "signedOfferRequired": "Please upload your signed offer letter before accepting"
      },
      "toast": {
        "documentUploaded": "Uploaded {{fileName}}",
        "documentRemoved": "Document removed",
        "documentsAlreadySubmitted": "All preboarding documents have already been submitted.",
        "documentsSubmitted": "All preboarding documents submitted and sent to recruitment team via email!",
        "signedOfferUploaded": "Signed offer letter uploaded successfully!",
        "offerAccepted": "Offer accepted — preboarding will begin",
        "offerDeclined": "Offer declined"
      },
      "placeholders": {
        "declineReason": "Please share the main reason",
        "declineContext": "Provide any additional context for the hiring team..."
      },
      "steps": {
        "preboarding": "Preboarding"
      }
    }
  },
  "toast": {
    "appraisalCycleCreated": "Appraisal cycle created",
    "reviewSubmitted": "Review submitted",
    "assetRequestSubmitted": "Asset request submitted",
    "applicationSubmitted": "Application submitted",
    "expenseClaimCreated": "Expense claim created",
    "structureCreated": "Structure created",
    "salaryAssigned": "Salary assigned",
    "documentUploaded": "Document uploaded",
    "bankDetailsSaved": "Bank details saved",
    "employmentDetailsSaved": "Employment details saved",
    "holidayTypeUpdated": "Holiday type updated",
    "holidayTypeCreated": "Holiday type created",
    "holidayTypeDeactivated": "Holiday type deactivated",
    "holidayTypeActivated": "Holiday type activated",
    "weekPatternUpdated": "Week pattern updated",
    "weekPatternCreated": "Week pattern created",
    "weekPatternDeactivated": "Week pattern deactivated",
    "weekPatternActivated": "Week pattern activated",
    "lifecycleEventRecorded": "Lifecycle event recorded",
    "geoCheckOutRecorded": "Geo check-out recorded",
    "geoCheckInRecorded": "Geo check-in recorded",
    "manualCheckOutRecorded": "Manual check-out recorded",
    "leaveRequestSubmitted": "Leave request submitted",
    "360FeedbackInvitationsSent": "360 feedback invitations sent",
    "holidayUpdated": "Holiday updated",
    "holidayAdded": "Holiday added",
    "holidayRemoved": "Holiday removed",
    "onboardingStarted": "Onboarding started",
    "exitInitiated": "Exit initiated",
    "exitFinalized": "Exit finalized",
    "loanRequestSubmitted": "Loan request submitted",
    "managerRemoved": "Manager removed",
    "reportingRelationshipSaved": "Reporting relationship saved",
    "payrollRunCreated": "Payroll run created",
    "payrollCalculatedAndProcessed": "Payroll calculated and processed",
    "statutoryReportExported": "Statutory report exported",
    "setupSeededSuccessfully": "Setup seeded successfully",
    "shiftUpdated": "Shift updated",
    "shiftDayUpdated": "Shift saved for this day",
    "shiftDayCleared": "Shift cleared for this day",
    "shiftChangeCancelled": "Shift change cancelled",
    "statutoryCsvDownloaded": "Statutory CSV downloaded",
    "planCreated": "Plan created",
    "courseCreated": "Course created",
    "trainingAssigned": "Training assigned",
    "travelRequestSubmitted": "Travel request submitted",
    "overrideRemoved": "Override removed",
    "weeklyOvertimeRecalculated": "Weekly overtime recalculated",
    "monthEndWorkforceProcessCompleted": "Month-end workforce process completed",
    "portalFiling": "{{portalCode}} filing {{status}} — ref {{ref}}",
    "reportExported": "{{reportType}} exported",
    "deviceRegistered": "Device registered. API key: {{apiKey}}",
    "weeklyOtAggregated": "Weekly OT aggregated for {{count}} employees",
    "hiringPolicySaved": "Hiring policy saved for {{company}}",
    "approvalPolicySaved": "Approval policy saved for {{company}}",
    "bankDetailsSubmittedForApproval": "Bank details submitted for approval",
    "travelRequestSettled": "Travel request settled."
  },
  "errors": {
    "failedToLoadFieldPermissions": "Failed to load field permissions",
    "failedToLoadCountryPacks": "Failed to load country packs",
    "failedToLoadShiftRotations": "Failed to load shift rotations",
    "selectACycleAndEmployee": "Select a cycle and employee",
    "failedToLoadAppraisalCycles": "Failed to load appraisal cycles",
    "failedToLoadReviews": "Failed to load reviews",
    "failedToCreateCycle": "Failed to create cycle",
    "failedToSubmitReview": "Failed to submit review",
    "employeeAndAssetTypeAreRequired": "Employee and asset type are required",
    "failedToCreateAssetRequest": "Failed to create asset request",
    "failedToLoadJobs": "Failed to load jobs",
    "applicationFailed": "Application failed",
    "employeeExpenseTypeDateAndAmountAreRequired": "Employee, expense type, date, and amount are required",
    "failedToCreateExpense": "Failed to create expense",
    "failedToLoadStructures": "Failed to load structures",
    "failedToCreateStructure": "Failed to create structure",
    "assignmentFailed": "Assignment failed",
    "failedToLoadAssignments": "Failed to load salary assignments",
    "selectDocumentTypeAndFile": "Select document type and file",
    "documentNameIsRequired": "Document name is required",
    "documentIdNumberIsRequiredForThisType": "Document ID / number is required for this type",
    "expiryDateIsRequiredForThisType": "Expiry date is required for this type",
    "employeeIsRequired": "Employee is required",
    "failedToLoadDocumentTypes": "Failed to load document types",
    "uploadFailed": "Upload failed",
    "bankNameAndAccountNumberAreRequired": "Bank name and account number are required",
    "failedToSaveBankDetails": "Failed to save bank details",
    "documentFileIsNotAvailable": "Document file is not available",
    "couldNotLoadPreviewOpeningInANew": "Could not load preview — opening in a new tab",
    "failedToLoadDocuments": "Failed to load documents",
    "reportingManagerIsRequired": "Reporting manager is required",
    "anEmployeeCannotBeTheirOwnManager": "An employee cannot be their own manager",
    "failedToSaveEmploymentDetails": "Failed to save employment details",
    "codeAndNameAreRequired": "Code and name are required",
    "failedToLoadHolidayTypes": "Failed to load holiday types",
    "deactivateFailed": "Deactivate failed",
    "activateFailed": "Activate failed",
    "failedToLoadWeekPatterns": "Failed to load week patterns",
    "failedToLoadDevices": "Failed to load devices",
    "registrationFailed": "Registration failed",
    "failedToLoadHierarchy": "Failed to load hierarchy",
    "failedToLoadEmployeeDetails": "Failed to load employee details",
    "lifecycleUpdateFailed": "Lifecycle update failed",
    "yourEmployeeProfileIsNotLinkedContactHr": "Your employee profile is not linked. Contact HR to link your account.",
    "leaveTypeAndAtLeastOneDayAre": "Leave type and at least one day are required",
    "leaveReasonIsRequired": "Leave reason is required",
    "failedToLoadEmployeeSelfServiceProfile": "Failed to load employee self-service profile",
    "failedToLoadScheduleAndTimeData": "Failed to load schedule and time data",
    "failedToLoadApprovalRequests": "Failed to load approval requests",
    "failedToLoadLeaveBalances": "Failed to load leave balances",
    "manualCheckOutFailed": "Manual check-out failed",
    "leaveApplicationFailed": "Leave application failed",
    "payslipDownloadFailed": "Payslip download failed",
    "launchFailed": "Launch failed",
    "failedToLoadSummary": "Failed to load summary",
    "dateAndNameAreRequired": "Date and name are required",
    "selectAHolidayTypeConfigureTypesOnThe": "Select a holiday type — configure types under Settings → HR Master Data → Holiday types first",
    "failedToLoadHolidays": "Failed to load holidays",
    "deleteFailed": "Delete failed",
    "selectAnEmployee": "Select an employee",
    "onboardingFailed": "Onboarding failed",
    "exitInitiationFailed": "Exit initiation failed",
    "exitFinalizeFailed": "Exit finalize failed",
    "employeeAndPrincipalAmountAreRequired": "Employee and principal amount are required",
    "failedToCreateLoanRequest": "Failed to create loan request",
    "failedToSaveLeaveType": "Failed to save leave type",
    "failedToSaveEmploymentType": "Failed to save employment type",
    "failedToSaveDocumentType": "Failed to save document type",
    "failedToSaveOvertimeType": "Failed to save overtime type",
    "failedToSaveShiftType": "Failed to save shift type",
    "failedToSaveExpenseType": "Failed to save expense type",
    "failedToSaveAssetType": "Failed to save asset type",
    "failedToSavePipelineStage": "Failed to save pipeline stage",
    "failedToLoadManagerDashboard": "Failed to load manager dashboard",
    "failedToLoadTeamHierarchy": "Failed to load team hierarchy",
    "youDoNotHavePermissionToChangeReporting": "You do not have permission to change reporting relationships",
    "employeeAndManagerMustBeDifferent": "Employee and manager must be different",
    "youDoNotHavePermissionToRemoveReporting": "You do not have permission to remove reporting relationships",
    "failedToLoadReportingHierarchy": "Failed to load reporting hierarchy",
    "dateHoursAndOvertimeTypeAreRequired": "Date, hours, and overtime type are required",
    "overtimeHoursMustBeGreaterThanZero": "Overtime hours must be greater than zero",
    "failedToLoadOvertimeRequests": "Failed to load overtime requests",
    "cancelFailed": "Cancel failed",
    "runCodeAndPeriodDatesAreRequired": "Run code and period dates are required",
    "failedToCreatePayrollRun": "Failed to create payroll run",
    "payrollCalculationFailedApproveTheRunFirst": "Payroll calculation failed — approve the run first",
    "statutoryExportFailed": "Statutory export failed",
    "failedToLoadTransactions": "Failed to load transactions",
    "disbursementExportFailed": "Disbursement export failed",
    "failedToScheduleInterview": "Failed to schedule interview",
    "failedToCompleteInterview": "Failed to complete interview",
    "failedToCreateOffer": "Failed to create offer",
    "assessmentFailed": "Assessment failed",
    "failedToAcceptOffer": "Failed to accept offer",
    "failedToDeclineOffer": "Failed to decline offer",
    "preboardingFailed": "Preboarding failed",
    "failedToApproveSelection": "Failed to approve selection",
    "failedToApproveOffer": "Failed to approve offer",
    "screeningFailed": "Screening failed",
    "probationConfirmationFailed": "Probation confirmation failed",
    "failedToExtendProbation": "Failed to extend probation",
    "bgvUpdateFailed": "BGV update failed",
    "failedToLoadWorkQueue": "Failed to load work queue",
    "failedToLoadPipeline": "Failed to load pipeline",
    "failedToLoadJobPostings": "Failed to load job postings",
    "failedToLoadRequisitions": "Failed to load requisitions",
    "failedToLoadManpowerRequests": "Failed to load manpower requests",
    "submitFailed": "Submit failed",
    "failedToCreateJobPosting": "Failed to create job posting",
    "failedToCreateRequisition": "Failed to create requisition",
    "failedToUpdateRequisition": "Failed to update requisition",
    "failedToCancelRequisition": "Failed to cancel requisition",
    "failedToDeleteRequisition": "Failed to delete requisition",
    "failedToCreateRequisitionFromManpower": "Failed to create requisition from manpower request",
    "failedToAddCandidate": "Failed to add candidate",
    "failedToCreateManpowerRequest": "Failed to create manpower request",
    "failedToUpdateManpowerRequest": "Failed to update manpower request",
    "failedToLoadManpowerAnalytics": "Failed to load workforce planning analytics",
    "failedToCancelManpowerRequest": "Failed to cancel manpower request",
    "failedToDeleteManpowerRequest": "Failed to delete manpower request",
    "failedToLoadAnalytics": "Failed to load analytics",
    "exportFailed": "Export failed",
    "failedToLoadHrSetup": "Failed to load HR setup",
    "failedToLoadHiringPolicy": "Failed to load hiring policy",
    "failedToLoadApprovalPolicy": "Failed to load approval policy",
    "seedFailed": "Seed failed",
    "failedToSaveHiringPolicy": "Failed to save hiring policy",
    "failedToSaveApprovalPolicy": "Failed to save approval policy",
    "failedToSaveWorkforceSettings": "Failed to save workforce settings",
    "shiftNameAndTypeAreRequired": "Shift name and type are required",
    "failedToUpdateShift": "Failed to update shift",
    "shiftAndAtLeastOneDayAreRequired": "Shift and at least one day are required",
    "cannotAssignShiftOnLeaveForEmployee": "{{employee}} is on leave on {{dates}}. A shift cannot be assigned on those days.",
    "endDateCannotBeBeforeStartDate": "End date cannot be before start date",
    "failedToLoadShiftAssignments": "Failed to load shift assignments",
    "failedToLoadShifts": "Failed to load shifts",
    "failedToLoadShiftChangeRequests": "Failed to load shift change requests",
    "failedToLoadShiftChangeHistory": "Failed to load shift change history",
    "downloadFailed": "Download failed",
    "failedToLoadSuccessionPlans": "Failed to load succession plans",
    "createFailed": "Create failed",
    "updateFailed": "Update failed",
    "failedToLoadTrainingCourses": "Failed to load training courses",
    "createCourseFailed": "Create course failed",
    "assignFailed": "Assign failed",
    "failedToLoadTravelRequests": "Failed to load travel requests",
    "dateIsRequired": "Date is required",
    "failedToRemoveOverride": "Failed to remove override",
    "weeklyOtAggregationFailed": "Weekly OT aggregation failed",
    "companyWeeklyOtFailed": "Company weekly OT failed",
    "monthEndFailed": "Month-end failed",
    "portalFilingFailed": "{{portalCode}} filing failed",
    "failedToLoadEmploymentTypes": "Failed to load employment types",
    "failedToLoadExpenseTypes": "Failed to load expense types",
    "failedToLoadLeaveTypes": "Failed to load leave types",
    "failedToLoadOvertimeTypes": "Failed to load overtime types",
    "failedToLoadShiftTypes": "Failed to load shift types",
    "failedToLoadCourses": "Failed to load courses",
    "failedToLoadAssetRequests": "Failed to load asset requests",
    "failedToLoadExpenseClaims": "Failed to load expense claims",
    "failedToLoadEmployees": "Failed to load employees",
    "failedToLoadLoanRequests": "Failed to load loan requests",
    "failedToLoadPayrollRuns": "Failed to load payroll runs",
    "failedToLoadTimesheet": "Failed to load timesheet",
    "failedToLoadTimesheetSummary": "Failed to load timesheet summary",
    "failedToPreviewRosterCopy": "Failed to preview roster copy",
    "failedToCopyRoster": "Failed to copy roster",
    "failedToUpdateShiftDay": "Failed to update shift for this day",
    "failedToPublishRoster": "Failed to publish roster",
    "receiptRequiredForExpenseType": "A receipt is required for this expense type.",
    "enterSettlementAmount": "Enter a settlement amount."
  },
  "pages": {
    "hrAdmin": "HR admin",
    "fieldPermissionsCountryPacksShiftRotation": "Field permissions, country packs, shift rotation patterns",
    "noFieldPermissions": "No field permissions",
    "noCountryPacks": "No country packs",
    "noShiftRotations": "No shift rotations",
    "performanceAppraisal": "Performance appraisal",
    "cyclesSelfManagerHrReviewsAnd": "Cycles, self/manager/HR reviews, and final ratings",
    "assetRequests": "Asset requests",
    "employeeAssetRequestsWithApprovalWorkflow": "Employee asset requests with approval workflow",
    "newAssetRequest": "New asset request",
    "submitAssetRequest": "Submit request",
    "expenseClaims": "Expense claims",
    "approvedClaimsLoaded": "Approved claims (loaded)",
    "pendingClaimsLoaded": "Pending claims (loaded)",
    "reimbursementsWithApprovalWorkflowAndFinance": "Reimbursements with approval workflow and finance integration",
    "compensation": "Compensation",
    "salaryStructuresAndEmployeeAssignments": "Salary structures and employee assignments",
    "noStructuresYet": "No structures yet",
    "noAssignmentsForThisEmployeeYet": "No assignments for this employee yet",
    "selectAnEmployee": "Select an employee",
    "expectedHours": "Expected hours",
    "expectedHoursToday": "Expected hours today",
    "expectedHoursThisWeek": "Expected hours this week",
    "expectedHoursThisMonth": "Expected hours this month",
    "expectedHoursThisYear": "Expected hours this year",
    "employeeExpectedHours": "Employee expected hours",
    "defaultExpectedHours": "Default expected hours",
    "workedHoursApproved": "Worked hours (approved)",
    "overtimeApproved": "Overtime (approved)",
    "employmentType": "Employment type",
    "employmentSummary": "Employment summary",
    "recentAttendance": "Recent attendance",
    "recentLeave": "Recent leave",
    "recentExpenses": "Recent expenses",
    "employmentDetails": "Employment details",
    "lifecycleHistory": "Lifecycle history",
    "employmentHistory": "Employment history",
    "attendanceHistory": "Attendance history",
    "leaveHistory": "Leave history",
    "payrollRuns": "Payroll runs",
    "bankDetails": "Bank details",
    "performanceReviews": "Performance reviews",
    "employeeDocuments": "Employee documents",
    "training": "Training",
    "assignedAssets": "Assigned assets",
    "chooseSomeoneFromTheDirectoryOr": "Choose someone from the directory or hierarchy to view their full HR profile.",
    "lastRecordedDays": "Last recorded days",
    "latestLeaveRequests": "Latest leave requests",
    "stageChangesAndHrEvents": "Stage changes and HR events",
    "noAttendanceRecords": "No attendance records",
    "noLeaveRecords": "No leave records",
    "noExpenseClaims": "No expense claims",
    "noPayrollRecords": "No payroll records",
    "noPerformanceReviews": "No performance reviews",
    "attendanceWillAppearHereOnceRecorded": "Attendance will appear here once recorded.",
    "leaveRequestsWillAppearHereOnce": "Leave requests will appear here once submitted.",
    "documentPreview": "Document preview",
    "editEmployment": "Edit employment",
    "assignDepartmentDesignationGradeAndBusiness": "Assign department, designation, grade, and business unit from your company master data. Create masters under HR → Master data if lists are empty.",
    "goToToday": "Go to today",
    "noHolidayTypesYet": "No holiday types yet",
    "workforceDetails": "Workforce details",
    "candidates": "Candidates",
    "leave": "Leave %",
    "attendanceRecords": "Attendance records",
    "workforceTimePayAndTalentScoped": "Workforce, time, pay, and talent — scoped to your role and reporting tree",
    "attendanceDevices": "Attendance devices",
    "biometricRfidQrAndFaceRecognition": "Biometric, RFID, QR, and face recognition connectors",
    "employeeDirectory": "Employee directory",
    "browseEmployeesExploreReportingHierarchyAnd": "Browse employees, explore reporting hierarchy, and manage profiles including documents",
    "employmentAtAGlance": "Employment at a glance",
    "leaveBalances": "Leave balances",
    "upcomingRoster": "Upcoming roster",
    "recentRoster": "Recent roster",
    "yourRecordsAtAGlance": "Your records at a glance",
    "attendance": "Attendance",
    "leaveRequests": "Leave requests",
    "payslips": "Payslips",
    "myApprovalRequests": "My approval requests",
    "overtime": "Overtime",
    "availableDaysByLeaveType": "Available days by leave type",
    "yourNextScheduledShiftsFromToday": "Your next scheduled shifts from today",
    "lastRosterEntriesForThisMonth": "Last roster entries for this month",
    "last5EntriesInEachArea": "Last 5 entries in each area — everything in one place",
    "recentCheckInsAndHours": "Recent check-ins and hours",
    "recentApplicationsAndStatus": "Recent applications and status",
    "recentPayrollRuns": "Recent payroll runs",
    "workflowStatusForYourSubmissions": "Workflow status for your submissions",
    "recentOvertimeRequests": "Recent overtime requests",
    "recentReimbursements": "Recent reimbursements",
    "assignedCourses": "Assigned courses",
    "applyForLeave": "Apply for leave",
    "availableLeave": "Available leave",
    "expectedMonth": "Expected (month)",
    "workedApproved": "Worked (approved)",
    "yourLeaveBalances": "Your leave balances",
    "noLeaveBalancesConfiguredForYourAccount": "No leave balances configured for your account.",
    "availableDaysReflectApprovedLeaveUsageOnly": "Available days reflect approved leave usage only. Pending requests are shown separately and do not reduce available until approved.",
    "yourProfileScheduleTimeLeavePay": "Your profile, schedule, time, leave, pay, and HR support in one place",
    "trackLeaveAndOtherHrRequests": "Track leave and other HR requests submitted for approval.",
    "downloadPdfPayslipsForProcessedPayroll": "Download PDF payslips for processed payroll runs.",
    "noLeaveHistory": "No leave history",
    "noPayslipsAvailable": "No payslips available",
    "submittedLeaveRequestsWillAppearHere": "Submitted leave requests will appear here.",
    "payslipsAppearAfterPayrollIsProcessed": "Payslips appear after payroll is processed.",
    "employment": "Employment",
    "bankDetailsForPayroll": "Bank details for payroll",
    "requiredDocumentTracking": "Required document tracking",
    "documents": "Documents",
    "assets": "Assets",
    "leaveSummary": "Leave summary",
    "recentAttendanceOvertime": "Recent attendance overtime",
    "typesConfiguredWithExpiryTracking": "Types configured with expiry tracking",
    "viewUploadAndDownloadYourHr": "View, upload, and download your HR documents",
    "companyAssetsAssignedToYou": "Company assets assigned to you",
    "noTrackedDocumentTypesConfigured": "No tracked document types configured",
    "noTrainingAssigned": "No training assigned",
    "noAssetsAssigned": "No assets assigned",
    "noReviewsYet": "No reviews yet",
    "noOvertimeFromAttendance": "No overtime from attendance",
    "workScheduleOverview": "Work schedule overview",
    "shiftAssignments": "Shift assignments",
    "roster": "Roster",
    "workCalendar": "Work calendar",
    "yourAssignedShiftsAndEffectivePeriods": "Your assigned shifts and effective periods",
    "daySpecificShiftOverridesForThis": "Day-specific shift overrides for this month",
    "resolvedScheduleIncludingHolidaysAndShift": "Resolved schedule including holidays and shift times",
    "noShiftAssignment": "No shift assignment",
    "noRosterEntriesThisMonth": "No roster entries this month",
    "yourHrTeamAssignsShiftsUnder": "Your HR team assigns shifts under Shifts. Company default calendar applies when none is set.",
    "rosterEntriesAppearWhenYourManager": "Roster entries appear when your manager plans a specific shift for a date.",
    "timeSummary": "Time summary",
    "expected": "Expected",
    "missing": "Missing",
    "overtimeRequests": "Overtime requests",
    "thisMonthAtAGlance": "This month at a glance",
    "manualOvertimeRequestsSubmittedForApproval": "Manual overtime requests submitted for approval",
    "noOvertimeRequestsThisMonth": "No overtime requests this month",
    "yourCheckInsAndAttendanceWill": "Your check-ins and attendance will appear here.",
    "overtimeFromAttendanceIsCalculatedAutomatically": "Overtime from attendance is calculated automatically when you check out.",
    "peerManagerAndSubordinateFeedbackCycles": "Peer, manager, and subordinate feedback cycles",
    "noFeedbackResponsesYet": "No feedback responses yet",
    "publicHolidays": "Public holidays",
    "companyCalendarDaysAndCustomizableHoliday": "Company calendar days and customizable holiday categories for attendance, leave, and schedules",
    "noHolidaysForThisYear": "No holidays for this year",
    "addHolidaysSoLeaveAndAttendance": "Add holidays so leave and attendance respect your company calendar.",
    "employeeLoans": "Employee loans",
    "loanRequestsWithPlatformApprovalWorkflow": "Loan requests with platform approval workflow",
    "addALeaveTypeFirstThen": "Add a leave type first, then configure policies for paid leave types",
    "noLeaveTypesYetAddYour": "No leave types yet — add your own",
    "noEmploymentTypesAddFullTime": "No employment types — add Full-time, Contract, Intern, etc.",
    "noDocumentTypesAddPassportVisa": "No document types — add Passport, Visa, Contract, etc.",
    "noOvertimeTypesYetAddTypes": "No overtime types yet — add types for working day, holiday, weekend, etc.",
    "noShiftTypesYetAddFixed": "No shift types yet — add Fixed, Flexible, Rotational, or your own categories",
    "noPipelineStagesDefaultsAreCreated": "No pipeline stages — defaults are created on first load",
    "noExpenseTypesYetAddTravel": "No expense types yet — add Travel, Meals, Supplies, etc.",
    "noAssetTypesYetAddLaptop": "No asset types yet — add Laptop, Phone, Monitor, etc.",
    "noBusinessUnitsYetAddYour": "No business units yet — add your company divisions",
    "noDepartmentsYetCreateTeamsEmployees": "No departments yet — create teams employees can be assigned to",
    "noGradesYetDefineJobLevels": "No grades yet — define job levels (e.g. G1, G2, Senior)",
    "noDesignationsYetAddJobTitles": "No designations yet — add job titles and link them to grades",
    "yourTeamHierarchyPendingApprovalsAnd": "Your team hierarchy, pending approvals, and team member records",
    "reportingHierarchy": "Reporting hierarchy",
    "viewAndManageWhoReportsTo": "View and manage who reports to whom. Departments, designations, grades, and business units are configured in HR master data.",
    "noOvertimeRequestsInThisPeriod": "No overtime requests in this period",
    "countryTemplatesSalaryCalculationAndFinance": "Country templates, salary calculation, and finance GL integration",
    "assessments": "Assessments",
    "backgroundVerification": "Background verification",
    "probationReview": "Probation review",
    "stageHistory": "Stage history",
    "scheduleInterview": "Schedule interview",
    "completeInterview": "Complete interview",
    "createOfferLetter": "Create offer letter",
    "scheduleAssessment": "Schedule assessment",
    "declineOffer": "Decline offer?",
    "recruitment": "Recruitment",
    "openPositions": "Open positions",
    "candidatesInPipeline": "Candidates in pipeline",
    "interviewsScheduled": "Interviews scheduled",
    "offersPending": "Offers pending",
    "preboarding": "Preboarding",
    "onboarding": "Onboarding",
    "joiningThisMonth": "Joining this month",
    "pendingRequisitions": "Pending requisitions",
    "pendingManpower": "Pending manpower",
    "probationPending": "Probation pending",
    "avgTimeToHireDays": "Avg time to hire (days)",
    "avgTimeToFillDays": "Avg time to fill (days)",
    "offerAcceptance": "Offer acceptance %",
    "joiningRatio": "Joining ratio %",
    "onboardingCompletion": "Onboarding completion %",
    "probationSuccess": "Probation success %",
    "totalHired": "Total hired",
    "totalApplied": "Total applied",
    "pendingInterviews": "Pending interviews",
    "pendingFeedback": "Pending feedback",
    "talentPool": "Talent pool",
    "pendingOffers": "Pending offers",
    "pendingPreboarding": "Pending preboarding",
    "pendingOnboarding": "Pending onboarding",
    "pendingBgv": "Pending BGV",
    "pendingConfirmations": "Pending confirmations",
    "searchCandidates": "Search candidates",
    "newRequisition": "New requisition",
    "editRequisition": "Edit requisition",
    "requisitionDetail": "Requisition details",
    "newJobPosting": "New job posting",
    "addCandidate": "Add candidate",
    "newManpowerRequest": "New manpower request",
    "editManpowerRequest": "Edit manpower request",
    "manpowerRequestDetail": "Manpower request details",
    "requisitionPostingPipelineOfferOnboardingEmployee": "Requisition → posting → pipeline → offer → onboarding → employee",
    "noManpowerRequestsCreateOneTo": "No manpower requests — create one to plan headcount",
    "noRequisitionsCreateAPositionRequisition": "No requisitions — create a position requisition to start hiring",
    "noJobPostingsApproveARequisition": "No job postings — approve a requisition and post a job",
    "hrReports": "HR reports",
    "headcount": "Headcount",
    "attendance2": "Attendance %",
    "pendingLeaves": "Pending leaves",
    "workforceAnalyticsAndStatutoryExports": "Workforce analytics and statutory exports",
    "generalHrSettings": "General HR settings",
    "companyPoliciesForHiringLeaveAttendance": "Company policies for hiring, leave, attendance, approvals, date & time display, and default HR seed data.",
    "noSetupDataYetSeedDefaults": "No setup data yet — seed defaults to populate",
    "editShift": "Edit shift",
    "shifts": "Shifts",
    "timesheet": "Timesheet",
    "assignShift": "Assign shift",
    "noShiftAssignments": "No shift assignments",
    "approvedAssignmentsAndPendingShiftChanges": "Approved assignments and pending shift changes appear here after you submit them.",
    "statutoryFiling": "Statutory filing",
    "automatedPortalSubmissionEpfoEcrEsic": "Automated portal submission (EPFO ECR, ESIC, TRACES) plus manual portal links",
    "successionPlanning": "Succession planning",
    "criticalPositionsSuccessorsAndRiskAnalysis": "Critical positions, successors, and risk analysis",
    "noSuccessionPlansYet": "No succession plans yet",
    "coursesAssignmentsAndCompletionTracking": "Courses, assignments, and completion tracking",
    "travelManagement": "Travel management",
    "travelRequestsApprovalAndSettlement": "Travel requests, approval, and settlement",
    "newTravelRequest": "New travel request",
    "workCalendarsSchedules": "Work calendars & schedules",
    "worked": "Worked",
    "dailyOt": "Daily OT",
    "weeklyOt": "Weekly OT",
    "chooseAnEmployeeToViewTheir": "Choose an employee to view their resolved work calendar, overrides, and weekly overtime for the selected month.",
    "noOverridesThisMonth": "No overrides this month",
    "noWeeklySummariesForThisMonth": "No weekly summaries for this month",
    "useTheFormAboveOrSwitch": "Use the form above or switch to calendar view and click a day to add an override.",
    "recalculateTheCurrentWeekOrWait": "Recalculate the current week or wait for the Sunday scheduler.",
    "compensationBenefits": "Compensation & Benefits",
    "feedback360": "360° Feedback"
  },
  "labels": {
    "reviewer": "Reviewer",
    "score": "Score",
    "comments": "Comments",
    "newCycleName": "New cycle name",
    "fullName": "Full name",
    "email": "Email",
    "role": "Role",
    "phone": "Phone",
    "structureName": "Structure name",
    "salaryStructure": "Salary structure",
    "grossAmount": "Gross amount",
    "effectiveFrom": "Effective from",
    "effectiveTo": "Effective to",
    "selectStructure": "Select structure",
    "selectOvertimeType": "Select overtime type",
    "overtimeType": "Overtime type",
    "calendarGranularity": "Calendar granularity",
    "loadingSchedule": "Loading schedule",
    "loadingCalendar": "Loading calendar",
    "documentName": "Document name",
    "documentIdNumber": "Document ID / number",
    "issueDate": "Issue date",
    "expiryDate": "Expiry date",
    "expiryDateOptional": "Expiry date (optional)",
    "documentFile": "Document file",
    "eGPassportEmiratesId": "e.g. Passport, Emirates ID",
    "enterTheIdShownOnThe": "Enter the ID shown on the document",
    "chooseADocumentToUpload": "Choose a document to upload",
    "bankName": "Bank name",
    "branch": "Branch",
    "accountNumber": "Account number",
    "ifscRoutingCode": "IFSC / routing code",
    "bank": "Bank",
    "account": "Account",
    "ifscRouting": "IFSC / routing",
    "optional": "Optional",
    "department": "Department",
    "designation": "Designations",
    "priority": "Priority",
    "store": "Store",
    "projectCode": "Project code",
    "hiringReason": "Hiring reason",
    "budgetAmount": "Budget amount",
    "budgetCurrency": "Budget currency",
    "expectedJoiningDate": "Expected joining date",
    "replacementEmployee": "Replacement employee",
    "justification": "Justification",
    "search": "Search",
    "status": "Status",
    "requestType": "Request type",
    "positions": "Positions",
    "location": "Location",
    "title": "Title",
    "grade": "Grade",
    "businessUnit": "Business unit",
    "anyDepartment": "Any department",
    "anyDesignation": "Any designation",
    "anyGrade": "Any grade",
    "anyUnit": "Any unit",
    "manager": "Manager",
    "loadingEmployeeProfile": "Loading employee profile",
    "employmentType": "Employment type",
    "assetType": "Asset type",
    "lifecycleEvents": "Lifecycle events",
    "eventType": "Event type",
    "effectiveDate": "Effective date",
    "allDepartments": "All departments",
    "allDesignations": "All designations",
    "allGrades": "All grades",
    "allBusinessUnits": "All business units",
    "employeeReportingHierarchy": "Employee reporting hierarchy",
    "code": "Code",
    "name": "Name",
    "description": "Description",
    "nonWorkingDay": "Full day off",
    "eGPub": "e.g. PUB",
    "displayName": "Display name",
    "noFileChosen": "No file chosen",
    "profileSections": "Profile sections",
    "timeDisplayUnit": "Time display unit",
    "defaultStart": "Default start",
    "defaultEnd": "Default end",
    "eGMf9": "e.g. MF9",
    "mondayFriday": "Monday – Friday",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "deviceName": "Device name",
    "deviceCode": "Device code",
    "employeeDirectoryNavigation": "Employee directory navigation",
    "searchEmployees": "Reporting members",
    "employees": "Employees",
    "loadingHierarchy": "Loading hierarchy",
    "employeeProfileDetails": "Employee profile details",
    "nameCodeOrEmail": "Name, code, or email",
    "lifecycle": "Lifecycle",
    "currentShift": "Current shift",
    "leaveDays": "Leave days",
    "loadingSelfServicePortal": "Loading self-service portal",
    "refreshPortalData": "Refresh portal data",
    "employeeCode": "Employee code",
    "reviewee": "Reviewee",
    "cycleId": "Cycle ID",
    "year": "Year",
    "date": "Date",
    "type": "Type",
    "selectType": "Select type",
    "reason": "Reason",
    "leaveType": "Leave type",
    "policyName": "Policy name",
    "accrual": "Accrual",
    "daysPerPeriod": "Days per period",
    "annualEntitlement": "Annual entitlement",
    "maxConsecutiveDays": "Max consecutive days",
    "maxCarryForward": "Max carry forward",
    "allowBackdatedLeave": "Allow backdated leave",
    "maxBackdatedDays": "Max backdated days",
    "policyActive": "Policy active",
    "paidLeave": "Paid leave",
    "carryForward": "Carry forward",
    "leaveTypeColor": "Leave type color",
    "payrollMode": "Payroll mode",
    "defaultHoursDay": "Default hours/day",
    "requiresEndDate": "Requires end date",
    "requiresReturnOnExit": "Requires return on exit",
    "trackExpiryDate": "Track expiry date",
    "applicableDay": "Applicable day",
    "receiptRequired": "Receipt required",
    "returnRequired": "Return required",
    "stageColor": "Stage color",
    "eGAnl": "e.g. ANL",
    "eGFtm": "e.g. FTM",
    "eGPas": "e.g. PAS",
    "eGWot": "e.g. WOT",
    "eGFix": "e.g. FIX",
    "eGTrv": "e.g. TRV",
    "eGPhoneScreen": "e.g. Phone screen",
    "eGScr": "e.g. SCR",
    "levelOrder": "Level order",
    "descriptionOptional": "Description (optional)",
    "businessUnitOptional": "Business unit (optional)",
    "parentDepartmentOptional": "Parent department (optional)",
    "departmentOptional": "Department (optional)",
    "gradeOptional": "Grade (optional)",
    "noBusinessUnit": "No business unit",
    "noParent": "No parent",
    "noDepartment": "No department",
    "noGrade": "No grade",
    "shiftColor": "Shift color",
    "employee": "Employee",
    "hours": "Hours",
    "from": "From",
    "to": "To",
    "runCode": "Run code",
    "countryFormulas": "Country (formulas)",
    "round": "Round",
    "dateTime": "Date & time",
    "score15": "Score (1–5)",
    "feedback": "Feedback",
    "salary": "Salary",
    "joiningDate": "Joining date",
    "offerMessage": "Offer message",
    "positionTitle": "Position title",
    "numberOfPositions": "Number of positions",
    "jobTitle": "Job title",
    "jobPosting": "Job posting",
    "source": "Source",
    "nameOrEmail": "Name or email…",
    "eGSalesExecutive": "e.g. Sales Executive",
    "eGChennai": "e.g. Chennai",
    "selectJob": "Select job",
    "eGQ3EngineeringHires": "e.g. Q3 engineering hires",
    "defaultApprovalMode": "Default approval mode",
    "hrManagersMayAutoApproveLeave": "HR managers may auto-approve leave filed on behalf of others",
    "newHirePath": "New hire path",
    "fullDay": "Full day",
    "halfDay": "Half day",
    "hourly": "Hourly",
    "maxHourlyLeaveDay": "Max hourly leave / day",
    "multiShiftPerDay": "Multi-shift per day",
    "maxShiftsPerDay": "Max shifts per day",
    "strictPresentAllShifts": "Strict present (all shifts)",
    "defaultTimeDisplay": "Default time display",
    "defaultCalendarView": "Default calendar view",
    "shiftName": "Shift name",
    "startTime": "Start time",
    "endTime": "End time",
    "shiftDays": "Shift days",
    "startDate": "Start date",
    "endDate": "End date",
    "criticalPosition": "Critical position",
    "incumbentEmployee": "Incumbent employee",
    "applyOverrideToEmployees": "Apply override to employees",
    "dayType": "Day type",
    "startOptional": "Start (optional)",
    "endOptional": "End (optional)",
    "purpose": "Purpose",
    "supportingDocumentOptional": "Supporting document (optional)",
    "employeeExpectedHours": "Employee expected hours",
    "defaultExpectedHours": "Default expected hours",
    "employeeHoursPeriod": "Employee hours period",
    "defaultHoursPeriod": "Hours period",
    "hoursPeriodPerDay": "Per day",
    "hoursPeriodPerWeek": "Per week",
    "hoursPeriodPerMonth": "Per month",
    "hoursPeriodPerYear": "Per year"
  },
  "lifecycleEvents": {
    "confirmed": "Confirmed",
    "promotion": "Promotion",
    "transfer": "Transfer",
    "probation": "Probation",
    "termination": "Termination",
    "resignation": "Resignation"
  },
  "formActions": {
    "saveOverride": "Save override",
    "savePolicy": "Save policy",
    "removeManager": "Remove manager",
    "saveReportingLine": "Save reporting line",
    "requestOvertime": "Request overtime",
    "createRequisition": "Create requisition",
    "createPosting": "Create posting",
    "addCandidate": "Add candidate",
    "createManpowerRequest": "Create request",
    "saveRequisitionDraft": "Save draft",
    "submitRequisition": "Submit for approval",
    "saveManpowerDraft": "Save draft",
    "submitManpowerRequest": "Submit for approval",
    "markSelected": "Mark selected",
    "createAndSendOffer": "Create & send offer",
    "scheduleAndComplete": "Schedule & complete",
    "saveChanges": "Save changes",
    "addHoliday": "Add holiday",
    "addType": "Add type",
    "updatePattern": "Update pattern",
    "createPattern": "Create pattern",
    "saveApprovalPolicy": "Save approval policy",
    "saveHiringPolicy": "Save hiring policy"
  },
  "setupPage": {
    "seedDefaults": "Seed defaults",
    "snapshotTitle": "Setup snapshot",
    "approvalPolicyTitle": "Approval workflow policy",
    "approvalPolicyDescription": "Per-company governance for leave, attendance, procurement, finance, and other approvals",
    "perModuleOverrides": "Per-module overrides",
    "perModuleOverridesHint": "Override the company default for specific modules. When not set to Yes, the default mode above applies.",
    "onBehalfAutoApproveHint": "When enabled, users with HR leave manage permission can submit leave for another employee and it is approved immediately without a workflow instance.",
    "hiringPolicyTitle": "Hiring policy",
    "hiringPolicyDescription": "Control whether new employees must come through recruitment or can be added directly",
    "forCompany": " for {{company}}",
    "companySuffix": " — {{company}}",
    "hiringModes": {
      "recruitment": {
        "label": "Recruitment only (recommended)",
        "description": "New hires must go through HR → Recruitment → Hire. Blocks direct Add employee."
      },
      "direct": {
        "label": "Allow direct employee creation",
        "description": "HR can add employees from Administration → Employees without the ATS workflow."
      }
    },
    "workflowModes": {
      "flexible": {
        "label": "Flexible (recommended)",
        "description": "Leave, attendance, procurement, and finance submissions work immediately. Approval buttons appear only when you configure workflows in Approvals."
      },
      "strict": {
        "label": "Require configured workflows",
        "description": "Submissions are blocked until an approval workflow is configured for that module. Use when governance must be enforced."
      }
    },
    "modules": {
      "HR": "HR (leave, attendance, payroll, …)",
      "PROCUREMENT": "Procurement",
      "FINANCE": "Finance",
      "INVENTORY": "Inventory",
      "CRM": "CRM",
      "DESK": "Desk",
      "POS": "POS",
      "WAREHOUSE": "Warehouse"
    },
    "workforce": {
      "loading": "Loading leave and attendance settings…",
      "savedToast": "Leave and attendance settings saved",
      "leaveModesTitle": "Leave request modes",
      "leaveModesDescription": "Configure leave duration types and shift attendance rules",
      "leaveSection": "Leave",
      "leaveSectionHint": "Which leave duration types employees can request and hourly limits.",
      "shiftSection": "Shift",
      "shiftSectionHint": "Multi-shift attendance and how present status is evaluated across shifts.",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "multiShiftDisabled": "Disabled (single shift)",
      "anyShiftPresent": "Any shift present",
      "allShiftsRequired": "All shifts required",
      "overtimeShiftSplit": "Overtime outside shift window",
      "overtimeShiftSplitEnabled": "Split before / after shift",
      "overtimeShiftSplitDisabled": "Excess over expected hours",
      "mobileAttendanceTitle": "Mobile & geo attendance",
      "mobileAttendanceHint": "Control device binding and geo-fence enforcement for employee self-service check-in.",
      "requireMobileBinding": "Require mobile device binding",
      "requireGeoAttendance": "Require geo attendance",
      "strictGeoFence": "Strict geo-fence",
      "strictGeoBlock": "Block outside fence",
      "strictGeoFlag": "Allow but flag",
      "calendarDefaultsTitle": "Attendance calendar defaults",
      "calendarDefaultsDescription": "Default time units and calendar zoom when users open Attendance. Individuals can still switch views during their session.",
      "saveLeaveModes": "Save leave request modes",
      "saveMobileAttendance": "Save mobile & geo attendance",
      "saveCalendarDefaults": "Save calendar defaults",
      "leaveModesSavedToast": "Leave request modes saved",
      "mobileAttendanceSavedToast": "Mobile & geo attendance settings saved",
      "calendarDefaultsSavedToast": "Attendance calendar defaults saved",
      "saveSettings": "Save leave & attendance settings",
      "laborRulesTitle": "Time, overtime & payroll rules",
      "laborRulesDescription": "Turn on advanced rules for overtime limits, compensatory rest banks (RCR/RCO), holiday premiums, meal allowances, and frozen timesheet snapshots at month-end.",
      "saveLaborRules": "Save labor rules",
      "laborRulesSavedToast": "Labor rules saved",
      "laborRules": {
        "enabled": "Enable labor rules",
        "enabledLabel": "Use advanced time & payroll rules for this company",
        "enabledHint": "When enabled, timesheets apply holiday premiums, paid-leave-as-worked, overtime contingent tracking, and comp-rest accrual according to the settings below. Allowances are configured under Compensation & Benefits.",
        "contingentHours": "Annual OT contingent (hours)",
        "contingentWarningPercent": "Contingent warning (%)",
        "rcrMode": "RCR accrual mode",
        "rcoMandatory": "RCO mandatory after contingent",
        "holidayPremiumRate": "Default holiday premium rate",
        "solidarityDay": "Solidarity day",
        "timesheetSnapshots": "Persist timesheet day snapshots on month-end",
        "rcrModes": {
          "payOnly": "Pay only",
          "replace": "Replace with RCR",
          "split": "Split pay and RCR"
        }
      },
      "periodFreezeTitle": "Period freeze",
      "periodFreezeDescription": "When enabled, past-date changes to shifts, holidays, and company calendar are blocked. When disabled, past changes still require a reason and approval.",
      "periodFreezeEnabled": "Enable period freeze",
      "attendanceFreezeGraceDays": "Attendance freeze grace days",
      "freezeOnRosterPublish": "Freeze after roster week is published",
      "freezeOnPayrollProcess": "Freeze after payroll is processed",
      "periodFreezeSavedToast": "Period freeze settings saved",
      "savePeriodFreeze": "Save period freeze"
    }
  },
  "correctionsPage": {
    "requestTitle": "Request master-data correction",
    "requestHint": "When period freeze is off, past dates can be changed through a correction with reason and approval. When period freeze is on, past-date changes are blocked.",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Explain why this historical change is required",
    "reasonRequired": "A reason is required",
    "submit": "Submit for approval",
    "submittedToast": "Correction submitted",
    "frozenBadge": "Frozen",
    "periodFrozenHint": "This date falls in a frozen HR period",
    "effectiveFromRequired": "Choose an effective date",
    "pastDateRequiresApproval": "Today or a past effective date requires an approved correction (period freeze is off)",
    "pastDateBlockedByFreeze": "Past-date changes are blocked while period freeze is enabled in HR setup. Disable period freeze to submit a correction with approval.",
    "historyRewriteBlockedByFreeze": "Company calendar changes rewrite historical schedules and are blocked while period freeze is enabled.",
    "versionHistoryTitle": "Version history",
    "loadingVersions": "Loading versions…",
    "noVersions": "No versions recorded yet",
    "versionLabel": "Version {{no}}",
    "openEnded": "current",
    "versionBreaksLabel": "Breaks",
    "versionNoBreaks": "No breaks in this version",
    "versionUnpaidTotal": "Unpaid {{minutes}}",
    "versionNonWorkingDay": "Non-working day",
    "versionSuperseded": "Superseded",
    "versionSupersededOn": "Replaced by a later change on {{date}}, never took effect"
  },
  "shiftsPage": {
    "pageDescriptionPrefix": "Assign shifts to employees. Working days without an assignment show company calendar hours. Define shift templates under",
    "pageDescriptionShiftLink": "HR master data → Shift definitions",
    "pageDescriptionMiddle": ". Manage company week patterns under",
    "pageDescriptionCompanyLink": "Settings → Companies",
    "assignEmployeeHint": "Assign the same shift to one or more employees.",
    "selectDaysHint": "Click or drag across days to select. Only the days you pick apply to this shift.",
    "assignRangeHint": "The selected shift is assigned to every day from the start date through the end date. It replaces any existing assigned shift on those days.",
    "assignRangeMultiHint": "Each selected shift is added on every day from the start date through the end date. Existing shifts on those days are kept when they do not overlap.",
    "assignRangeCount": "{{count}} day(s) · {{from}} – {{to}}",
    "addShift": "Add another shift",
    "additionalShift": "Additional shift",
    "removeShift": "Remove",
    "duplicateShiftsSelected": "Select each shift only once.",
    "shiftTimesOverlap": "Selected shifts overlap. Choose shifts with non-overlapping times.",
    "multiShiftRequired": "Multiple shifts per day are not enabled for this company.",
    "maxShiftsExceeded": "At most {{count}} shifts can be assigned on the same day.",
    "copySchedule": "Copy schedule",
    "copyScheduleTitle": "Copy schedule",
    "copyScheduleHint": "Choose what to copy or swap. Changes appear on the calendar as a draft. Publish when the schedule is final.",
    "copyKindLabel": "What do you want to do?",
    "copyKindDates": "Same employees, different dates",
    "copyKindDatesHint": "Repeat a week or month of shifts on later dates.",
    "copyKindEmployee": "One employee to other employees",
    "copyKindEmployeeHint": "Give other employees the same shift pattern for the days you pick.",
    "copyKindSwap": "Swap shifts between employees",
    "copyKindSwapHint": "Exchange two employees' assigned shifts on the days you pick.",
    "copyFromEmployee": "Copy shifts from",
    "copyFromEmployeeHint": "The employee whose shift pattern is copied.",
    "copyToEmployees": "Copy shifts to",
    "copyToEmployeesHint": "Every selected employee gets the same shifts. The source employee is skipped when pasting on the same dates.",
    "copyDaysLegend": "Days to copy",
    "copyWeekdaysLabel": "Limit to weekdays (optional)",
    "copyWeekdaysHint": "Leave all unselected to copy every day in the range.",
    "copyWeekdaysClear": "Clear",
    "copyWeekdayMon": "Mon",
    "copyWeekdayTue": "Tue",
    "copyWeekdayWed": "Wed",
    "copyWeekdayThu": "Thu",
    "copyWeekdayFri": "Fri",
    "copyWeekdaySat": "Sat",
    "copyWeekdaySun": "Sun",
    "copyPasteOnLabel": "Paste on",
    "copyPasteSameDates": "The same dates",
    "copyPasteStartDate": "A different start date",
    "copyConflictLabel": "If the employee already has a shift that day",
    "copyConflictSkip": "Keep the existing shift and skip that day",
    "copyConflictOverwrite": "Replace the day with the copied shifts",
    "copyEmployeePreview": "Copy assigned shifts {{from}} → {{to}} to {{count}} employee(s) as {{targetFrom}} → {{targetTo}}",
    "copyEmployeePreviewConfirm": "Copy {{source}}'s assigned shifts from {{from}} → {{to}} to {{count}} employee(s) as {{targetFrom}} → {{targetTo}}",
    "copyAssignedOnlyHint": "Only assigned employee shifts are copied. Company default hours on empty days are not included.",
    "copyEmployeeIncomplete": "Pick a source employee, a date range, and at least one employee to copy to.",
    "copySwapEmployeeA": "First employee",
    "copySwapEmployeeAHint": "This employee's shifts move to the second employee.",
    "copySwapEmployeeB": "Second employee",
    "copySwapEmployeeBHint": "This employee's shifts move to the first employee.",
    "copySwapDaysLegend": "Days to swap",
    "copySwapWeekdaysHint": "Leave all unselected to swap every day in the range.",
    "copySwapPreview": "Swap assigned shifts between the two employees {{from}} → {{to}}",
    "copySwapPreviewConfirm": "Swap {{source}} and {{target}} assigned shifts from {{from}} → {{to}}",
    "copySwapIncomplete": "Pick two different employees and a date range to swap.",
    "copySwapAssignedOnlyHint": "Only assigned employee shifts are swapped. Company default hours on empty days are not included.",
    "copySourceLabel": "Copy from",
    "copySourceVisibleWeek": "Visible week",
    "copySourceVisibleMonth": "Visible month",
    "copySourceSingleDay": "Single day",
    "copySourceWeekNumber": "Week number",
    "copySourceMonth": "Month",
    "copySourceCustomRange": "Custom date range",
    "copySourceDay": "Source day",
    "copyRangeFrom": "From",
    "copyRangeTo": "To",
    "copyWeekNumber": "Week number",
    "copyMonth": "Month",
    "copyYear": "Year",
    "copyTargetLabel": "Paste to",
    "copyTargetNextDay": "Next day (shift by 1 day)",
    "copyTargetNextWeek": "Next week (shift by 7 days)",
    "copyTargetNextMonth": "Next month (same dates +1 month)",
    "copyTargetSpecificDate": "Specific start date",
    "copyTargetStartDate": "Target start date",
    "copyTargetStartDateHint": "The first source day maps to this date; later days keep the same spacing. Example: 31 Jul–6 Aug starting 1 Aug becomes 1–7 Aug.",
    "copyTargetWeekNumber": "Target week number",
    "copyTargetMonth": "Target month",
    "copyRangePreview": "Copy {{sourceFrom}} → {{sourceTo}} to start at {{targetFrom}}",
    "copyTargetMode_NEXT_DAY": "next day",
    "copyTargetMode_NEXT_WEEK": "next week",
    "copyTargetMode_NEXT_MONTH": "next month",
    "copyTargetMode_CUSTOM": "custom date",
    "copyToNextWeek": "Copy to next week",
    "copyWeekTitle": "Employees",
    "copyWeekHint": "Copy the visible week's schedule forward by one week.",
    "copyWeekScopeAll": "All employees with shifts in source range",
    "copyWeekScopeSelected": "Selected employees only",
    "copyWeekSelectEmployees": "Employees to copy",
    "copyWeekEmployeesRequired": "Select at least one employee",
    "copyWeekEmployeesHint": "Only employees with shifts in the source range are copied.",
    "copyPreviewTitle": "Confirm schedule copy",
    "copyPreviewTitleSwap": "Confirm shift swap",
    "copyPreviewSummary": "{{count}} assignment(s) will be copied. {{conflicts}} conflict(s) detected.",
    "copyPreviewSummarySwap": "{{count}} assignment(s) will be swapped.",
    "copyPreviewShifts": "Shifts:",
    "copyNothingToStage": "No shifts found to copy for the selected range.",
    "copyNothingToSwap": "No assigned shifts found to swap for the selected range.",
    "draftSchedule": "Draft (not published)",
    "editDraftShift": "Edit this day (draft)",
    "editDraftShiftHint": "Changes save immediately. Publish when the schedule is final.",
    "clearDraftShift": "Clear day",
    "publish": "Publish",
    "expectedColumn": "Expected",
    "noEmployeesInScope": "No employees in your visibility scope.",
    "leaveDayBlocked": "On leave — a shift cannot be assigned on this day",
    "assignBlockedByLeave": "This range includes leave days. Remove those days or pick another range."
  },
  "timesheetPage": {
    "title": "Timesheet",
    "description": "Monthly worked hours, leave, absences, and payroll-ready buckets per employee.",
    "selectEmployeeHint": "Select an employee to view their timesheet.",
    "summary": {
      "worked": "Worked hours",
      "effective": "Effective worked",
      "overtime": "Overtime",
      "absenceDays": "Absence days",
      "paidLeaveWorked": "Paid leave as worked",
      "manual": "Manual attendance",
      "holidayPremium": "Holiday premium"
    },
    "badges": {
      "leave": "Leave",
      "absence": "Absence",
      "manual": "Manual",
      "solidarity": "Solidarity"
    },
    "tooltip": {
      "worked": "Worked {{value}}",
      "expected": "Expected {{value}}",
      "leave": "Leave: {{type}}",
      "absence": "Absence: {{code}}",
      "manual": "Manual attendance",
      "holidayWorked": "Holiday worked",
      "solidarity": "Solidarity day",
      "premium": "Premium {{value}}"
    }
  },
  "workforcePage": {
    "tabs": {
      "employee": "Employee schedule",
      "company": "Company templates & batch"
    },
    "dayTypes": {
      "WORKING": "Working day",
      "WEEKEND": "Weekend",
      "HOLIDAY": "Holiday",
      "HALF_DAY": "Half day",
      "SPECIAL": "Special day"
    },
    "toast": {
      "overrideSaved": "Calendar override saved"
    },
    "empty": {
      "selectEmployeeForOverride": "Select an employee to view or pick employees for bulk override"
    },
    "bulkOverrideHint": "Leave empty to apply only to the employee selected above. Select multiple for bulk override.",
    "employeeSchedule": "Employee schedule",
    "shiftSummary": "Shift: {{shift}} · {{days}} working days · {{hours}}/day",
    "defaultPattern": "Default pattern",
    "workCalendarHint": "Click a day to edit. Overrides take precedence over company calendar and holidays.",
    "weeklyOvertime": "Weekly overtime",
    "recalculateCurrentWeek": "Recalculate current week",
    "weekPatternTemplates": "Week pattern templates",
    "weekPatternTemplatesHint": "Reusable working-week templates for the active company. Assign a pattern under Org → Companies → Calendar tab.",
    "batchOperations": "Batch operations",
    "batchOperationsHint": "Run company-wide processes. Month-end feeds payroll and attendance summaries for the current month.",
    "runMonthEnd": "Run month-end"
  },
  "holidaysPage": {
    "companyWorkCalendar": "Company work calendar",
    "infoBanner": "Holidays apply to the <strong>active company</strong> in the header switcher. Configure weekly working days under Administration → Companies → Calendar. Manage holiday categories on the <strong>Holiday types</strong> tab on this page.",
    "laborRulesHint": "Timesheet treatment and premium rate apply when advanced labor rules are enabled (HR Setup → Workforce policy). Set a holiday to Worked holiday if employees may work that day and earn a premium; set Solidarity day for solidarity-day tracking.",
    "pastEditHint": "Future holiday dates can be saved directly. When period freeze is off, today or past dates need a correction with reason and approval. When period freeze is on, past dates cannot be changed.",
    "requestCorrection": "Request correction",
    "calendarMissing": "Holiday calendar is not ready yet. Refresh and try again.",
    "tabs": {
      "calendar": "Holiday calendar",
      "types": "Holiday types"
    },
    "holidayCount": "{{count}} holiday(s) in {{year}}",
    "noTypesWarning": "No active holiday types for this company.",
    "addTypesLink": "Add holiday types",
    "addTypesSuffix": "before creating calendar entries.",
    "editHoliday": "Edit holiday",
    "addHoliday": "Add holiday",
    "editHolidayType": "Edit holiday type",
    "addHolidayType": "Add holiday type",
    "nonWorkingYes": "Yes — office / schedule closed",
    "nonWorkingNo": "No — observed day (optional / worked)",
    "cancelEdit": "Cancel edit",
    "typesDescription": "Define the holiday categories your company uses (e.g. public, regional, optional). When adding a holiday on the calendar tab, pick one of these types. Deactivate types you do not need instead of deleting them.",
    "treatmentLabel": "Timesheet treatment",
    "premiumRateLabel": "Premium rate (optional)",
    "premiumRatePlaceholder": "e.g. 1.5 — uses company default if empty",
    "confirmDeleteTitle": "Delete holiday",
    "confirmDeleteMessage": "Delete {{name}}? This action cannot be undone.",
    "validation": {
      "invalidYear": "Enter a whole year from 2000 to 2100.",
      "nameTooLong": "Holiday name must be 150 characters or fewer.",
      "invalidPremium": "Premium rate must be from 0 to 9999.9999 with no more than 4 decimal places.",
      "typeFieldsTooLong": "Holiday type name must be 120 characters or fewer and description 255 characters or fewer."
    },
    "columns": {
      "treatment": "Treatment",
      "premiumRate": "Premium rate"
    },
    "treatment": {
      "off": "Full day off",
      "worked": "Worked holiday (premium if attended)",
      "solidarity": "Solidarity day"
    }
  },
  "leaveBehavior": {
    "title": "Timesheet & payroll behavior",
    "description": "How this leave type affects worked hours, scheduling, meal allowances, and compensatory rest banks.",
    "countsAsWorkedHours": "Counts as worked hours",
    "countsAsWorkedHoursHint": "Paid leave minutes count toward effective worked time on the timesheet.",
    "countsTowardOvertimeThreshold": "Counts toward overtime threshold",
    "generatesMealAllowance": "Generates meal allowance",
    "deductsFromLeaveBalance": "Deducts from leave balance",
    "blocksScheduling": "Blocks shift scheduling",
    "requiresDocument": "Requires supporting document",
    "isCompensatoryRest": "Compensatory rest leave",
    "isCompensatoryRestHint": "When approved, debits the selected RCR or RCO bank.",
    "restBankType": "Rest bank to debit",
    "restBankPlaceholder": "Select bank",
    "restBank": {
      "rcr": "RCR — compensatory rest",
      "rco": "RCO — over-contingent rest"
    },
    "premiumPayEligible": "Eligible for premium pay"
  },
  "compRest": {
    "title": "Compensatory rest balances",
    "description": "RCR and RCO hour banks for {{year}}. Accruals come from approved overtime; consumption from compensatory rest leave.",
    "rcrBalance": "RCR balance",
    "rcoBalance": "RCO balance",
    "noTransactions": "No comp-rest movements yet",
    "noTransactionsHint": "Approve overtime (with RCR accrual enabled) or take compensatory rest leave to see activity here.",
    "columns": {
      "date": "Date",
      "bank": "Bank",
      "type": "Type",
      "change": "Change",
      "balance": "Balance",
      "reason": "Reason"
    },
    "errors": {
      "loadFailed": "Failed to load compensatory rest balances"
    }
  },
  "adminPage": {
    "fieldPermissions": "Field permissions",
    "countryPacks": "Country packs",
    "shiftRotations": "Shift rotations"
  },
  "weekPatterns": {
    "description": "Create company-specific week patterns. Assign one to the work calendar — no fixed presets required.",
    "editTitle": "Edit week pattern",
    "newTitle": "New week pattern",
    "daysHeading": "Days (1 = Monday)",
    "applyDefaults": "Apply default times to working days",
    "savedPatterns": "Saved patterns",
    "columns": {
      "day": "Day",
      "working": "Working",
      "halfDay": "Half day",
      "start": "Start",
      "end": "End"
    },
    "weekdays": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    }
  },
  "workflowStatus": {
    "pending": "Pending approval",
    "approved": "Approved",
    "rejected": "Rejected",
    "returned": "Returned for changes"
  },
  "approvalRow": {
    "cancellationPending": "Cancellation pending approval",
    "cancellationPendingShort": "cancellation pending",
    "hideEdit": "Hide edit",
    "hideApproval": "Hide approval",
    "approvalAndHistory": "Approval & history"
  },
  "listActions": {
    "submit": "Submit",
    "edit": "Edit",
    "view": "View",
    "delete": "Delete",
    "applyFilters": "Apply filters",
    "clearFilters": "Clear filters",
    "close": "Close",
    "postJob": "Post job",
    "createRequisition": "Create requisition",
    "openRequisition": "Open requisition",
    "scheduleInterview": "Schedule interview",
    "createOffer": "Create offer",
    "createCycle": "Create cycle",
    "createPlan": "Create plan",
    "createStructure": "Create structure",
    "assignSalary": "Assign salary",
    "submitRequest": "Submit request",
    "startOnboarding": "Start onboarding",
    "initiateExit": "Initiate exit",
    "finalizeExit": "Finalize exit",
    "launch360": "Launch 360",
    "viewSummary": "View summary",
    "registerDevice": "Register device",
    "submitApplication": "Submit application",
    "settle": "Settle",
    "cancel": "Cancel"
  },
  "messages": {
    "uploadTravelSupportingFile": "Upload travel itinerary, invitation letter, or other supporting file."
  },
  "reports": {
    "filterTitle": "Report period",
    "dateRangeInvalid": "Start date must be on or before end date",
    "dualSheetHint": "Excel exports include detailed rows and a per-employee summary. Attendance includes punch source (Manual, Geo, Web, etc.). Filters (period, status, employee) apply to detail rows. Data respects company scope and your hierarchy visibility.",
    "workforceSection": "Workforce reports",
    "otherSection": "Other reports",
    "allRecords": "All records",
    "allEmployees": "All employees",
    "employeeFilter": "Employee",
    "employeeFilterPlaceholder": "All employees in your view",
    "periodMonth": "This month",
    "periodWeek": "This week",
    "periodCustom": "Custom range",
    "formats": {
      "CSV": "CSV",
      "EXCEL": "Excel"
    },
    "tabs": {
      "exports": "Standard exports",
      "payrollHandoff": "Payroll handoff"
    },
    "payrollHandoff": {
      "title": "Payroll handoff",
      "description": "Review payroll readiness, dynamic allowances, approved expenses, claims, attendance, timesheets, and payroll preview before payroll generation.",
      "year": "Year",
      "month": "Month",
      "employeeId": "Employee ID",
      "downloadCsv": "Download CSV",
      "downloadExcel": "Download Excel",
      "invalidPeriod": "Enter a valid year and month",
      "employeesReady": "Employees ready",
      "payrollExceptions": "Payroll exceptions",
      "totalPayrollCost": "Total payroll cost",
      "reimbursementCost": "Expense & claim cost",
      "allowanceCost": "Allowance cost",
      "expenseCost": "Expense cost",
      "claimCost": "Claim cost",
      "attendanceSummary": "Attendance summary",
      "workedDays": "Worked",
      "leaveDays": "Leave",
      "overtime": "Overtime",
      "lateHours": "Late",
      "payrollComponents": "Payroll components",
      "basicSalary": "Basic salary",
      "variableEarnings": "Variable earnings",
      "deductions": "Deductions",
      "netPayPreview": "Net pay preview",
      "allowances": "Allowances",
      "expenses": "Expenses",
      "claims": "Claims",
      "validations": "Validations",
      "none": "None",
      "noEmployees": "No employees found for this payroll period."
    },
    "types": {
      "ATTENDANCE": "Attendance",
      "LEAVE": "Leave",
      "OVERTIME": "Overtime",
      "SCHEDULE_COMPLIANCE": "Schedule compliance",
      "PAYROLL_READINESS": "Payroll readiness",
      "PAYROLL": "Payroll",
      "ALLOWANCE_SUMMARY": "Allowance summary",
      "ALLOWANCE_BY_TYPE": "Allowance by type",
      "ALLOWANCE_BY_DEPARTMENT": "Allowance by department",
      "EXPENSE_SUMMARY": "Expense summary",
      "CLAIM_SUMMARY": "Claim summary",
      "PAYROLL_EXCEPTIONS": "Payroll exceptions",
      "PENDING_APPROVALS": "Pending approvals",
      "PAYROLL_VARIANCE": "Payroll variance",
      "PAYROLL_COST_ANALYSIS": "Payroll cost analysis",
      "RECRUITMENT": "Recruitment",
      "TRAINING": "Training",
      "PERFORMANCE": "Performance",
      "ATTRITION": "Attrition",
      "EMPLOYMENT_HISTORY": "Employment history"
    }
  },
  "import": {
    "title": {
      "attendance": "Bulk Excel import — Attendance",
      "shifts": "Bulk Excel import — Shifts",
      "overtime": "Bulk Excel import — Overtime",
      "leave": "Bulk Excel import — Leave"
    },
    "description": {
      "attendance": "Upload check-in and check-out times (.xlsx or CSV). The system calculates worked hours, expected hours, and overtime before import.",
      "shifts": "Upload employee shift assignments by date. Rows are submitted for approval like manual shift changes.",
      "overtime": "Upload standalone overtime requests (hours or minutes) for employees in your visibility scope.",
      "leave": "Upload leave requests (full-day, half-day, or hourly). Rows follow the same validation and approval path as manual leave."
    },
    "steps": "1. Download the sample Excel · 2. Replace example rows with your data · 3. Upload to validate · 4. Import valid rows (warnings are included)",
    "expand": "Expand section",
    "collapse": "Collapse section",
    "downloadSample": "Download sample Excel",
    "downloadSampleHint": "Download an Excel template with the correct columns and an Instructions sheet",
    "selectFile": "Upload Excel or CSV",
    "validating": "Validating…",
    "selectedFile": "Selected: {{name}}",
    "emptyCell": "—",
    "emptyPreview": "No rows to preview",
    "summary": "{{valid}} valid, {{errors}} errors, {{warnings}} warnings — fix errors or import valid/warning rows only.",
    "importAll": "Import all ({{count}} rows)",
    "importValidOnly": "Import valid rows only ({{count}})",
    "templateFilenames": {
      "attendance": "attendance-import-template.xlsx",
      "shifts": "shifts-import-template.xlsx",
      "overtime": "overtime-import-template.xlsx",
      "leave": "leave-import-template.xlsx"
    },
    "columns": {
      "row": "Row",
      "employeeCode": "Employee code",
      "status": "Status",
      "messages": "Messages"
    },
    "status": {
      "valid": "Valid",
      "error": "Error",
      "warning": "Warning"
    },
    "preview": {
      "checkIn": "Check in",
      "checkOut": "Check out",
      "workedHours": "Worked (h)",
      "expectedHours": "Expected (h)",
      "overtimeHours": "OT (h)",
      "overtimeType": "OT type",
      "lateMinutes": "Late (min)",
      "assignmentDate": "Date",
      "shiftName": "Shift",
      "overtimeDate": "Date",
      "hours": "Hours",
      "leaveType": "Leave type",
      "startDate": "Start",
      "endDate": "End",
      "durationMode": "Duration",
      "halfDaySession": "Half-day session",
      "leaveHours": "Leave hours",
      "reason": "Reason"
    },
    "errors": {
      "fileRequired": "Select an Excel or CSV file first.",
      "templateDownloadFailed": "Could not download sample Excel.",
      "validationFailed": "Import validation failed.",
      "importFailed": "Import failed."
    },
    "toast": {
      "templateDownloaded": "Sample Excel downloaded.",
      "validated": "Validated {{count}} row(s). Review the preview before importing.",
      "imported": "Imported {{count}} row(s) successfully.",
      "partialFailure": "{{count}} row(s) failed to import — review the preview table.",
      "noRowsImported": "No rows were imported. Fix errors and try again."
    }
  },
  "scheduleBreaks": {
    "title": "Scheduled breaks",
    "add": "Add break",
    "remove": "Remove",
    "name": "Name",
    "start": "Start",
    "end": "End",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "unpaidExpected": "Unpaid {{unpaid}} · Expected {{expected}}",
    "empty": "No scheduled breaks. Paid breaks do not reduce expected hours.",
    "insideError": "Each break must be fully inside the scheduled time.",
    "overlapError": "Break periods cannot overlap.",
    "consumeWindowError": "Unpaid breaks must be shorter than the scheduled time."
  },
  "attendanceBreaks": {
    "reason": "Break reason",
    "reasonPlaceholder": "Lunch, tea, personal...",
    "start": "Start break",
    "end": "End break",
    "started": "Break started",
    "ended": "Break ended",
    "startFailed": "Unable to start break",
    "endFailed": "Unable to end break",
    "empty": "No actual breaks recorded.",
    "inProgress": "In progress",
    "defaultName": "Break"
  },
  "franceOnboarding": {
    "title": "Employee details",
    "editTitle": "Update employee details",
    "description": "Complete the employee's identity, job, contract and salary details.",
    "stepsLabel": "Employee details steps",
    "sections": {
      "personal": "Personal details",
      "contract": "Job & contract",
      "benefits": "Benefits & allowances"
    },
    "sectionDescriptions": {
      "personal": "Identity, address, national identification, bank and emergency contact.",
      "contract": "Organisation, contract type, collective agreement and gross salary.",
      "benefits": "Meal allowance, health insurance and bank confirmation."
    },
    "fields": {
      "firstName": "First name",
      "lastName": "Surname",
      "sex": "Sex",
      "email": "Email ID",
      "phone": "Phone",
      "dateOfBirth": "Date of birth",
      "placeOfBirth": "Place of birth",
      "birthDepartment": "Region / department of birth",
      "addressLine": "Street address",
      "postalCode": "Postal code",
      "city": "City",
      "nationality": "Nationality",
      "nir": "Social security / national ID number",
      "familyStatus": "Family status",
      "iban": "IBAN / bank account number",
      "emergencyContactName": "Emergency contact name",
      "emergencyContactRelationship": "Emergency contact relationship",
      "emergencyContactPhone": "Emergency contact phone",
      "contractType": "Contract type",
      "employmentStatut": "Employment status",
      "designation": "Designations",
      "ccn": "Collective agreement",
      "classification": "Classification / Coefficient",
      "contractStartDate": "Contract start date",
      "contractEndDate": "Contract end date",
      "trialPeriod": "Trial period",
      "trialPeriodUnit": "Unit",
      "workTimeType": "Working time",
      "hoursPerWeek": "Hours per week",
      "salaryBasis": "Gross salary basis",
      "grossSalary": "Gross salary",
      "hourlyGross": "Gross hourly rate",
      "weeklyGross": "Gross weekly salary",
      "monthlyGross": "Calculated monthly gross",
      "foodAllowanceType": "Food allowance type",
      "foodAllowanceValue": "Food allowance value",
      "mutuelleStatus": "Health insurance",
      "ribConfirmed": "Bank details confirmed"
    },
    "hints": {
      "ribConfirmed": "I confirm that the employee's bank details have been checked."
    },
    "options": {
      "sex": {
        "M": "Male",
        "F": "Female",
        "NB": "Non-binary",
        "OTHER": "Other",
        "UNDISCLOSED": "Prefer not to say"
      },
      "familyStatus": {
        "CELIBATAIRE": "Single",
        "MARIE": "Married",
        "PACSE": "Civil partnership (PACS)",
        "DIVORCE": "Divorced",
        "VEUF": "Widowed"
      },
      "contractType": {
        "CDI": "Permanent contract (CDI)",
        "CDD": "Fixed-term contract (CDD)",
        "ALTERNANCE": "Work-study contract",
        "STAGE": "Internship"
      },
      "employmentStatut": {
        "NON_CADRE": "Non-managerial",
        "AGENT_MAITRISE": "Supervisory staff",
        "CADRE": "Executive"
      },
      "trialPeriodUnit": {
        "DAYS": "Days",
        "MONTHS": "Months"
      },
      "workTimeType": {
        "TEMPS_PLEIN": "Full time",
        "TEMPS_PARTIEL": "Part time"
      },
      "salaryBasis": {
        "ANNUAL": "Annual",
        "MONTHLY": "Monthly",
        "WEEK": "Weekly",
        "HOURLY": "Hourly"
      },
      "foodAllowanceType": {
        "TICKET_RESTAURANT": "Meal voucher",
        "INDEMNITE_REPAS": "Meal allowance",
        "NONE": "None"
      },
      "mutuelleStatus": {
        "OPT_IN": "Enrolled",
        "DISPENSE": "Exemption"
      },
      "yes": "Yes",
      "no": "No"
    },
    "actions": {
      "previous": "Previous",
      "next": "Next",
      "save": "Save employee details",
      "complete": "Save employee details",
      "cancel": "Cancel",
      "onboardEmployee": "Add employee",
      "completeOnboarding": "Complete employee details",
      "useTrialSuggestion": "Use statutory suggestion"
    },
    "validation": {
      "email": "Enter a valid email address.",
      "nir": "NIR must contain exactly 15 digits.",
      "nationalId": "National ID must contain between 5 and 32 characters.",
      "iban": "Enter a valid 27-character French IBAN.",
      "ibanAndRib": "A valid French IBAN and RIB confirmation are required.",
      "bankAccount": "Enter a valid IBAN or bank account number.",
      "bankAccountAndConfirmation": "A valid bank account and bank details confirmation are required.",
      "endAfterStart": "The contract end date must be after the start date.",
      "positive": "Enter a value greater than zero."
    },
    "errors": {
      "load": "Unable to load employee onboarding.",
      "save": "Unable to save employee onboarding.",
      "completeFormFirst": "Complete the employee onboarding form before editing bank details."
    },
    "toast": {
      "created": "Employee details saved.",
      "updated": "Employee details updated."
    },
    "portal": {
      "personalTitle": "Your personal details",
      "personalHint": "Required information for your employee file. The same details appear on the recruiter preboarding screen.",
      "personalSaved": "Personal details saved",
      "personalSave": "Save personal details",
      "personalRequired": "Complete and save your personal details before submitting documents.",
      "hrWillCompleteTitle": "Your employer will complete",
      "hrWillCompleteHint": "HR fills these employee fields on the preboarding / onboarding screen. You do not need to enter them.",
      "hrItems": {
        "org": "Job title, department, manager and app role",
        "contract": "Contract type, start/end dates and trial period",
        "ccn": "Collective agreement and classification",
        "hours": "Expected hours and gross salary"
      }
    },
    "incompleteBanner": "Employee details are incomplete. Complete identity, contract and salary information before processing payroll.",
    "bank": {
      "title": "Bank details",
      "description": "Verified bank details used for payroll disbursement.",
      "edit": "Edit bank details",
      "add": "Add bank details",
      "save": "Save bank details",
      "empty": "No bank details are on file."
    },
    "master": {
      "tab": "Collective agreements",
      "tabDescription": "Maintain company CCNs and their coefficient classifications.",
      "ccnTitle": "Collective agreements",
      "ccnDescription": "The collective agreements applicable to this company.",
      "classificationTitle": "Classifications",
      "classificationDescription": "Coefficient and minimum salary grids by collective agreement.",
      "addCcn": "Add CCN",
      "editCcn": "Edit CCN",
      "addClassification": "Add classification",
      "editClassification": "Edit classification",
      "idcc": "IDCC",
      "code": "Code",
      "name": "Name",
      "ccn": "CCN",
      "coefficient": "Coefficient",
      "label": "Label",
      "minimumMonthly": "Minimum monthly salary",
      "minimumHourly": "Minimum hourly rate",
      "status": "Status",
      "active": "Active",
      "inactive": "Inactive",
      "edit": "Edit",
      "delete": "Delete",
      "saved": "Collective agreement data saved.",
      "deleted": "Collective agreement data deleted.",
      "saveError": "Unable to save collective agreement data.",
      "confirmDeleteCcn": "Delete the collective agreement “{{name}}”?",
      "confirmDeleteClassification": "Delete the classification “{{name}}”?"
    }
  },
  "common": {
    "active": "Active",
    "inactive": "Inactive",
    "pendingApproval": "Pending approval",
    "yes": "Yes",
    "no": "No",
    "uncategorized": "Uncategorized",
    "edit": "Edit",
    "deactivate": "Deactivate"
  },
  "allowances": {
    "title": "Compensation & Benefits",
    "newType": "New Allowance Type",
    "summary": {
      "types": "Allowance types",
      "activeTypes": "Active types",
      "assignments": "Assignments",
      "pendingApproval": "Pending approval"
    },
    "toast": {
      "typeUpdated": "Allowance type updated",
      "typeCreated": "Allowance type created",
      "typeDeactivated": "Allowance type deactivated",
      "assignmentSubmitted": "Allowance assignment submitted for approval"
    },
    "errors": {
      "assignmentRequired": "Employee, allowance type, and effective from date are required",
      "saveTypeFailed": "Failed to save allowance type",
      "deactivateFailed": "Failed to deactivate allowance type",
      "createAssignmentFailed": "Failed to create allowance assignment"
    },
    "placeholders": {
      "category": "Choose allowance category",
      "formula": "Example: worked_days * 150 or gross * 0.05",
      "customFieldsJson": "Example: {\"kilometers\": 100, \"trips\": 2}",
      "selectType": "Select allowance type",
      "amountOverride": "Optional — uses type default when blank"
    },
    "columns": {
      "code": "Code",
      "name": "Name",
      "category": "Category",
      "calculation": "Calculation",
      "default": "Default",
      "delivery": "Delivery",
      "payrollComponent": "Payroll component",
      "status": "Status",
      "actions": "Actions",
      "employee": "Employee",
      "allowance": "Allowance",
      "override": "Override",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "source": "Source"
    },
    "calculationMethods": {
      "FIXED_AMOUNT": "Fixed amount - same amount every payroll",
      "PER_DAY_WORKED": "Per day worked - amount x worked days",
      "PER_ATTENDANCE": "Per attendance - amount x attendance days",
      "PER_SHIFT": "Per shift - amount x completed shifts",
      "PER_HOUR": "Per hour - amount x worked hours",
      "PER_MONTH": "Per month - monthly recurring amount",
      "PER_WEEK": "Per week - amount x payroll weeks",
      "PER_PROJECT": "Per project - project linked allowance",
      "PER_KILOMETER": "Per kilometer - mileage based",
      "PER_TRIP": "Per trip - travel trip based",
      "PER_EXPENSE": "Per expense - expense linked",
      "PERCENT_BASIC": "Percentage of basic salary",
      "PERCENT_GROSS": "Percentage of gross salary",
      "PERCENT_OTHER_ALLOWANCE": "Percentage of another allowance",
      "FORMULA_BASED": "Formula based - advanced payroll formula",
      "MANUAL_ENTRY": "Manual entry - entered during assignment/payroll",
      "APPROVAL_BASED": "Approval based - requires assignment approval",
      "CUSTOM_RULE": "Custom rule - advanced expression"
    },
    "deliveryModes": {
      "PAYROLL": "Automatic payroll allowance",
      "CLAIM": "Employee claim - reuse HR Claims",
      "EXPENSE": "Reimbursable expense - reuse Expense module"
    },
    "taxTreatment": {
      "TAXABLE": "Taxable",
      "NON_TAXABLE": "Non-taxable",
      "PARTIALLY_TAXABLE": "Partially taxable"
    }
  },
  "employees": {
    "placeholders": {
      "hoursExample": "e.g. 8"
    }
  }
}
